import React, { useState } from "react";
import InnerHaeder from "../Component/InnerHaeder";
import Highlights from "../Component/Highlights";
import Footer from "../Component/Footer";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Link } from "react-router-dom";
import HeadTag from "../Component/HeadTags";
import LazyLoad from "react-lazyload";
const TrainingTrainers = () => {
  return (
    <>
      <HeadTag title="Training Trainers" />
      <Highlights />
      <InnerHaeder />
      <div className="inner_page">
        <div className="container-fluid flwidth testi_sec trainers">
          <div className="bgimage">
            <h5>
              <Link to="/">
               
                Home <i className="fas fa-angle-right"></i>{" "}
              </Link>
              <span>
               
                Co-Curricular <i className="fas fa-angle-right"></i> Training
                Trainers
              </span>
            </h5>
            <h2>Training Trainers</h2>
          </div>
          <Tabs className="Tabs">
            <TabList>
              <Tab>2026 - 2027</Tab>
              <Tab>2025 - 2026</Tab>
              <Tab>2024 - 2025</Tab>
              <Tab>2023 - 2024</Tab>
              <Tab>2022 - 2023</Tab>
              <Tab>2021 - 2022</Tab>
              <Tab>2020 - 2021</Tab>
              <Tab>2019 - 2020</Tab>
            </TabList>
            <TabPanel>
              <div class="accordion accordion-flush" id="accordionFlushExample">
                <div class="accordion-item">
                  <h2
                    class="accordion-header"
                    id="trainerrjan-headingAgeCareer10"
                  >
                    <button
                      class="accordion-button collapsed show"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#trainerrjan-collapseAgeCareer10"
                      aria-expanded="false"
                      aria-controls="trainerrjan-collapseAgeCareer10"
                    >
                      January
                    </button>
                  </h2>
                  <div
                    id="trainerrjan-collapseAgeCareer10"
                    class="accordion-collapse collapse show"
                    aria-labelledby="trainerrjan-headingAgeCareer10"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            Moving Forward by 1°: A Paradigm Shift in
                            Professional Excellence
                          </h3>
                          <p>
                            "At 99°, water is merely hot; at 100°, it boils,
                            generating the steam that powers the engine. That
                            singular, extra degree makes all the difference." •
                            Mr. S. Hali and Mrs. Mona Verma On 17 January 2026,
                            Lotus Valley International School, Noida Extension,
                            hosted a transformative workshop, "Moving Forward by
                            1° More." Welcomed by Principal Ms. Indu Yadav,
                            resource persons Mr. S. Hali and Mrs. Mona Verma
                            guided faculty through modules focused on elevating
                            workplace engagement. The session challenged
                            educators to transcend comfort zones by dissecting
                            the "impact vs. activity" dilemma and fostering
                            mentor-mentee dynamics to catalyze incremental yet
                            profound professional growth. The discourse
                            transitioned into high-level productivity
                            frameworks, including the Eisenhower Matrix for
                            strategic prioritization and the Kanban Board for
                            workflow optimization. By addressing the
                            psychological roots of passive procrastination and
                            the pitfalls of perfectionism, the facilitators
                            provided tools to align daily efforts with
                            excellence. This segment empowered staff to audit
                            their routines, ensuring a shift from mere busyness
                            to meaningful instructional impact. The workshop
                            concluded by exploring behavioral psychology,
                            integrating the Pomodoro Technique with emotional
                            intelligence and anger management. Discussions on
                            intrinsic motivation and constructive feedback loops
                            equipped facilitators with the resilience needed for
                            modern education. This comprehensive program
                            successfully carved a progressive path, enabling
                            educators to transmute their professional journeys
                            into impactful learning experiences for their
                            students. #ProfessionalDevelopment
                            #EducationalExcellence #LotusValley #GrowthMindset
                            #TeacherTraining #StrategicLeadership
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/stem-1.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/stem-2.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/stem-3.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/stem-4.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/stem-5.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/stem-6.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/stem-7.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/stem-8.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/stem-9.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/stem-10.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/stem-13.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/stem-14.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/stem-15.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/stem-16.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/stem-17.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            Report Teacher Training - Healthy Teachers, Healthy
                            Classrooms
                          </h3>
                          <p>
                            “Fitness is not about being better than someone
                            else. It’s about being better than you used to be.”
                            - Khloe Kardashian To begin the new year with a
                            positive and healthy start, a workshop titled
                            ‘Healthy Teachers, Healthy Classrooms - Your
                            Personal Nutrition Blueprint’ was organised for
                            teachers on Saturday, 10 January 2026. The session
                            was conducted by Ms Aditi Mehrotra, who brought
                            valuable insights on teacher wellness and holistic
                            health. Ms Mehrotra began the workshop by
                            introducing Arney’s Fitkids as a wellness-integrated
                            network, emphasising that teachers are the most
                            important stakeholders in building healthy
                            classrooms and must prioritise their own well-being.
                            She highlighted the strong mind-body connection and
                            explained how healthy food choices directly impact
                            mental health and overall performance. Using
                            engaging examples such as the mixed nuts analogy,
                            she explained balance in nutrition and lifestyle.
                            The session also covered mental wellness hacks,
                            including the 3-3-3 rule to manage stress and
                            enhance emotional balance. Teachers were enlightened
                            with myths and facts related to common food items,
                            helping them make informed dietary choices. The
                            workshop was highly interactive and included
                            practical activities such as low-impact,
                            joint-friendly chair exercises for lymphatic
                            pumping, a brain dump activity linked to
                            neuro-linguistic programming, and a rainbow tracker
                            activity highlighting the importance of consuming
                            all colours of food in a day for complete nutrition.
                            The session concluded with a question-and-answer
                            round, leaving teachers motivated and inspired,
                            reinforcing the idea that healthy teachers create
                            healthy classrooms.
                            #healthyteachershealthyclassrooms #teacherwellness
                            #nutritionforeducators #mindbodyconnection
                            #mentalwellbeing #fitteachersfitstudents
                            #wellnessatwork #healthystart2026
                            #teacherempowerment #arney’sfitkids #lvisne
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/health-1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/health-2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/health-3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/health-4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                       
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/health-6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/health-7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/health-8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/health-9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/health-10.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/health-11.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/health-12.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/health-13.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                   
                    <div class="accordion-body"></div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div class="accordion accordion-flush" id="accordionFlushExample">
                <div class="accordion-item">
                  <h2
                    class="accordion-header"
                    id="trainermay-headingAgeCareer9"
                  >
                    <button
                      class="accordion-button collapsed show"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#trainermay-collapseAgeCareer9"
                      aria-expanded="false"
                      aria-controls="trainermay-collapseAgeCareer9"
                    >
                      December
                    </button>
                  </h2>
                  <div
                    id="trainermay-collapseAgeCareer9"
                    class="accordion-collapse collapse show"
                    aria-labelledby="trainermay-headingAgeCareer9"
                  >
                   
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Empowering Educators Through STEM Training</h3>
                          <p>
                            A STEM Workshop titled “Empowering Educators Through
                            STEM Training” was organised at Lotus Valley
                            International School, Noida Extension, in the STEAM
                            Lab on 6 December 2025. The workshop was conducted
                            by STEM ROBO Technologies for the Science and IT
                            Department teachers of Grades I–XII, with Mr. Nikesh
                            Sharma, Senior Engineer, STEM ROBO Technologies, as
                            the resource person. A total of 27 teachers
                            participated in the workshop. The objective of the
                            session was to familiarise educators with emerging
                            technologies and innovative digital tools to enhance
                            classroom teaching and promote experiential
                            learning. The workshop commenced with an engaging
                            and interactive session on Kahoot, an online
                            assessment and quiz platform. Teachers were guided
                            on creating interactive quizzes, conducting
                            real-time assessments, and making classroom learning
                            more student-centric, engaging, and enjoyable. This
                            was followed by a hands-on session on Tinkercad,
                            where participants were introduced to the basics of
                            3D design and simulation. Teachers explored how
                            Tinkercad can be effectively used to create models,
                            design electric circuits online, and foster design
                            thinking among students. They also actively
                            participated in assembling basic electronic
                            circuits, which strengthened their understanding of
                            fundamental electronics concepts and boosted their
                            confidence to conduct similar classroom activities.
                            The participants were further introduced to AI
                            Connect, during which the resource person
                            highlighted the growing significance of Artificial
                            Intelligence in modern classrooms. He demonstrated
                            how AI-based tools such as ZeroGPT, QuillBot,
                            Grammarly, and PopAi can support teachers in
                            enhancing lesson delivery, improving content
                            quality, and streamlining academic tasks. The
                            workshop concluded with an immersive Virtual Reality
                            (VR) experience. Teachers explored how VR tools can
                            be used to explain complex concepts through
                            simulated environments, thereby extending learning
                            beyond textbooks and promoting deeper conceptual
                            understanding. Overall, the STEM Workshop proved to
                            be highly informative, interactive, and enriching.
                            It equipped teachers with practical skills,
                            innovative digital tools, and modern pedagogical
                            strategies aligned with STEM education, fostering
                            curiosity, creativity, and experiential learning in
                            the classroom. #EmpoweringEducators #STEMWorkshop
                            #STEMEducation #TeacherTraining
                            #ExperientialLearning #DigitalPedagogy
                            #InnovativeTeaching #FutureReadyClassrooms #EdTech
                            #AIinEducation #VRinEducation #3DDesign #Tinkercad
                            #KahootLearning #ProfessionalDevelopment
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/empower-1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/empower-2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/empower-3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/empower-4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/empower-5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/empower-6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            English Language Training Workshop: “NeuroRead – The
                            Cognitive Science of Transformative Reading”
                          </h3>
                          <p>
                            On 6th December 2025, Lotus Valley International
                            School, Noida Extension, in collaboration with
                            English Press, conducted an enriching English
                            Language Training Workshop titled “NeuroRead: The
                            Cognitive Science of Transformative Reading.” The
                            session was led by the distinguished academician and
                            master trainer, Ms. Prakriti Srivastava, whose
                            expertise illuminated the intricate interplay
                            between cognition, emotion, and reading. The
                            workshop explored innovative pedagogical approaches
                            by bridging literature, musical reading, theatre,
                            and visual-graphic language, enabling educators to
                            deepen comprehension and enhance cognitive focus in
                            learners. The dignitaries from English Press
                            conveyed their appreciation to the school leadership
                            for fostering a culture of continuous professional
                            growth. The engaging session empowered educators
                            with refined strategies to make reading a
                            transformative, multisensory experience for
                            students. #NeuroRead #TeacherTraining
                            #LotusValleyNoidaExtension #TransformativeReading
                            #EnglishPress #ProfessionalDevelopment
                            #21stCenturyLearning
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/el1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/el2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/el3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/el4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/el5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/el6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/el7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/el8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            Report-Gaining insights into the NEP 2020 and NCF
                            2023 Grades-Nursery-KG
                          </h3>
                          <p>
                            The facilitators of Nursery to Kindergarten at Lotus
                            Valley International School, Noida Extension,
                            enthusiastically participated in the Physical
                            Augmentation Session held on Saturday, December 6,
                            2025, in collaboration with our curriculum partner,
                            NatureNurture. The session was expertly facilitated
                            by Ms. Geeta Mehrotra and Ms. Baiza Shabir, whose
                            engaging delivery and deep expertise enriched the
                            learning experience for all participants. The
                            workshop provided a dynamic platform for educators
                            to deepen their understanding of NEP 2020 and NCF
                            2023, with a special focus on strengthening
                            classroom practices across the Early Years. A key
                            highlight of the session was the clear and
                            insightful explanation of the Panchakosha framework,
                            emphasizing holistic child development, as well as
                            the Panchpadi teaching–learning process, which
                            helped teachers reflect on structured, meaningful,
                            and experiential classroom engagement. Through
                            interactive discussions, reflection circles, and
                            collaborative exchanges, facilitators were inspired
                            to rethink instructional strategies, enrich learning
                            environments, and ensure meaningful assessments
                            aligned with NCF.The session concluded with renewed
                            motivation and a shared commitment to fostering
                            joyful, holistic, and impactful learning experiences
                            for our young learners. #lotusvalleynoidaextension
                            #earlyyearseducation #teacherdevelopment #nep2020
                            #ncf2023 #innovativepractices #holisticlearning
                            #joyfuleducation #educatorsatlvis
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/ncf1.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/ncf2.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/ncf3.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/ncf4.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/ncf5.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/ncf6.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/ncf7.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/cbse8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/ncf8.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/ncf9.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/ncf10.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/ncf11.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/ncf12.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/ncf13.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/ncf14.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/ncf15.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-body"></div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2
                    class="accordion-header"
                    id="trainermay-headingAgeCareer3"
                  >
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#trainermay-collapseAgeCareer3"
                      aria-expanded="false"
                      aria-controls="trainermay-collapseAgeCareer3"
                    >
                      November
                    </button>
                  </h2>
                  <div
                    id="trainermay-collapseAgeCareer3"
                    class="accordion-collapse collapse"
                    aria-labelledby="trainermay-headingAgeCareer3"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            CBSE Capacity Building Programme on English Core
                            (Senior Secondary)
                          </h3>
                          <p>
                            “A teacher’s growth is the first spark that ignites
                            a student’s future.” Lotus Valley International
                            School, Noida Extension hosted the CBSE Capacity
                            Building Two-Day Programme for English Core Senior
                            Secondary teachers on 14 and 15 November 2025.
                            Conducted by Ms. Sangeeta Rekhi and Ms. Shantwana
                            Das, the workshop engaged English educators in
                            strengthening classroom practices aligned with NPST
                            and NEP 2020. The sessions covered all sections of
                            the English Core paper, offering strategies for
                            effective classroom management and enhanced learner
                            engagement. Participants explored activity-based
                            methodologies, purposeful acronyms for improving
                            writing skills, and progressive learning approaches
                            that spanned pronunciation, morphemes, and syllable
                            awareness. Storytelling techniques, peer learning,
                            and reflective assessment practices were highlighted
                            to deepen comprehension. Literature discussions
                            emphasized clarity, expression, individuality of
                            thought, and creating the right mood and tone. The
                            programme fostered an enriching, future-ready
                            perspective on English pedagogy. #CapacityBuilding
                            #CBSEWorkshop #EnglishCore #TeacherTraining
                            #ProfessionalDevelopment #NPSTAligned #NEP2020
                            #21stCenturyTeaching
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/cbse1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/cbse2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/cbse3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/cbse4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/cbse5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/cbse6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/cbse7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/cbse8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            Teaching is a lifelong journey of learning,
                            reflection, and growth.
                          </h3>
                          <p>
                            At Lotus Valley International School, Noida
                            Extension, this belief was reinforced during a
                            training session on the National Curriculum
                            Framework (NCF) conducted by Ms. Chandeep Marwah on
                            Saturday, 1 November 2025, for facilitators of
                            Grades I–III. The session began with an engaging
                            Palm Activity linking experiential learning with key
                            NCF principles.
                            <br />
                            Ms. Marwah explained the difference between a
                            syllabus and a curriculum, the significance of the
                            Foundational Years, and the Panchakosha philosophy
                            of holistic development. Facilitators explored
                            components of lesson planning and pedagogical
                            approaches with a focus on play-based learning.
                            Through discussions and collaborative activities,
                            they reflected on storytelling as a tool for
                            imagination and emotional connection, and on
                            toy-based pedagogy for creativity and
                            problem-solving. <br />
                            The session also touched upon foundational numeracy,
                            positive classroom environments, and scaffolding
                            strategies. At Lotus Valley, we believe such
                            professional learning opportunities empower
                            facilitators to nurture joyful, inclusive, and
                            holistic classrooms, reflecting the true essence of
                            the NCF. <br />
                            #LotusValleyNoidaExtension #NCF #Pedagogy
                            #FoundationalYears #Storytelling #PlayBasedLearning
                            #NIPUN #VidyaPravesh
                          </p>
                        </div>

                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/TrainingReport-1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/TrainingReport-2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/TrainingReport-3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/TrainingReport-4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>

                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/TrainingReport-5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2
                    class="accordion-header"
                    id="trainermay-headingAgeCareer2"
                  >
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#trainermay-collapseAgeCareer2"
                      aria-expanded="false"
                      aria-controls="trainermay-collapseAgeCareer2"
                    >
                      September
                    </button>
                  </h2>
                  <div
                    id="trainermay-collapseAgeCareer2"
                    class="accordion-collapse collapse"
                    aria-labelledby="trainermay-headingAgeCareer2"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>CBSE- Happy Classroom Workshop</h3>
                          <p>
                            A CBSE capacity building workshop on ‘Happy
                            Classrooms’ was organized at Lotus Valley
                            International School, Noida Extension on 13
                            September, 2025, to promote joyful teaching–learning
                            practices and enhance classroom well-being. The
                            session was conducted by eminent CBSE Resource
                            Persons, Ms. Vandana Rastogi and Ms. Chanchal
                            Mittal, both accomplished educators with extensive
                            experience in psychology, counselling, and
                            capacity-building. The program commenced with a
                            lamp-lighting ceremony, symbolizing the spread of
                            knowledge and happiness, followed by a warm welcome
                            address by the principal, Ms Indu Yadav. Through
                            interactive activities, case discussions, and
                            practical strategies, the speakers emphasized
                            creating a positive environment where empathy,
                            creativity, and collaboration form the foundation of
                            learning. Educators actively participated in the
                            engaging sessions, gaining insights into innovative
                            pedagogies, behaviour management, and the importance
                            of fostering student well-being. The event proved to
                            be an enriching experience, inspiring teachers to
                            transform classrooms into joyful spaces that nurture
                            holistic development and lifelong learning.
                            #HappyClassrooms #CBP #CBSE #LearnUnlearnRelearn
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/HappyClassroom1.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/HappyClassroom2.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/HappyClassroom3.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/HappyClassroom4.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/HappyClassroom5.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/HappyClassroom6.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/HappyClassroom7.jpeg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2
                    class="accordion-header"
                    id="trainermay-headingAgeCareer1"
                  >
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#trainermay-collapseAgeCareer1"
                      aria-expanded="false"
                      aria-controls="trainermay-collapseAgeCareer1"
                    >
                      August
                    </button>
                  </h2>
                  <div
                    id="trainermay-collapseAgeCareer1"
                    class="accordion-collapse collapse"
                    aria-labelledby="trainermay-headingAgeCareer1"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            CBSE CBP- Promoting Mental Health among Students
                          </h3>
                          <p>
                            “Mental health is not a luxury, it is a necessity.”
                            With this thought in mind, Lotus Valley
                            International School, Noida Extension hosted a CBSE
                            Capacity Building Workshop on ‘Promoting Mental
                            Health among Students’ on 23rd August 2025. The
                            workshop was conducted by Mr. Dinesh Narula and Ms.
                            Nutan Verma, both highly experienced educators who
                            brought valuable insights into the importance of
                            nurturing emotional well-being along with academic
                            success. The session was highly interactive, with
                            teachers enthusiastically participating in
                            team-based activities and discussions. Each group
                            displayed creativity, collaboration, and reflective
                            thinking, making the workshop engaging and
                            impactful. The activities encouraged teachers to
                            re-examine classroom practices and explore
                            strategies that promote empathy, resilience, and
                            mindfulness among students. The workshop proved to
                            be both fruitful and meaningful, equipping teachers
                            with practical tools to foster confidence, emotional
                            balance, and overall well-being in learners.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/promote-mental-health-1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/promote-mental-health-2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/promote-mental-health-3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/promote-mental-health-4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/promote-mental-health-5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/promote-mental-health-6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/promote-mental-health-7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/promote-mental-health-8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/promote-mental-health-9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/promote-mental-health-10.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/promote-mental-health-11.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/promote-mental-health-12.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/promote-mental-health-13.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2
                    class="accordion-header"
                    id="trainermay-headingAgeCareer1"
                  >
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#trainermay-collapseAgeCareer"
                      aria-expanded="false"
                      aria-controls="trainermay-collapseAgeCareer"
                    >
                      July
                    </button>
                  </h2>
                  <div
                    id="trainermay-collapseAgeCareer"
                    class="accordion-collapse collapse"
                    aria-labelledby="trainermay-headingAgeCareer1"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>(SQAAF)-CBSE Training Session</h3>
                          <p>
                            “Quality is never an accident; it is always the
                            result of intelligent effort.” – John Ruskin
                            <br />
                            In keeping with this profound thought, Lotus Valley
                            International School, Noida Extension hosted a
                            two-day Capacity Building Programme on the School
                            Quality Assessment and Assurance Framework (SQAAF)—a
                            CBSE initiative aimed at fostering structured
                            self-assessment, reflection, and continuous school
                            improvement. The programme was held on Friday, 27th
                            June 2025, and Saturday, 28th June 2025. The
                            programme aligned with the school’s vision of
                            fostering excellence through collaboration,
                            innovation, and continuous learning. The session
                            commenced with a warm welcome and the ceremonial
                            lighting of the lamp, symbolising the pursuit of
                            knowledge. The school was privileged to host Ms.
                            Poonam Sachdev, Head of the Centre of Excellence,
                            Noida, along with two distinguished resource
                            persons—Dr. Smita Mishra, Principal of Karl Huber
                            School, Noida, and Ms. Monica Chawla, Principal of
                            St. Joseph’s Sr. Sec. School, Chandigarh. The
                            sessions offered valuable insights into quality
                            benchmarks across curriculum, pedagogy, leadership,
                            infrastructure, and stakeholder engagement,
                            prompting school leaders to reflect critically on
                            institutional practices. Ms. Indu Yadav, revered
                            Principal,Lotus Valley International School, Noida
                            Extension addressed the gathering, reaffirming the
                            commitment to building inclusive, future-ready
                            institutions. The programme concluded with a token
                            of gratitude and a shared resolve to drive
                            purposeful change across schools.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/SQAAF1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/SQAAF2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/SQAAF3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/SQAAF4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/SQAAF5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/SQAAF6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/SQAAF7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/SQAAF8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/SQAAF9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/SQAAF10.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/SQAAF11.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/SQAAF12.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>

                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Adobe CPD Workshop for Teachers</h3>
                          <p>
                            A professional development workshop on Adobe Express
                            was held on 19th July 2025 (Saturday) at the Senior
                            ICT Lab for teachers of the Pre-Primary, Primary,
                            Middle, and Senior wings. Conducted by Ms. Jasmeet,
                            an expert from the Adobe for Education program, the
                            session focused on creating dynamic digital lesson
                            plans, academic calendars, and class webpages to
                            streamline classroom organisation. Teachers were
                            introduced to innovative digital tools that
                            integrate class resources onto a unified platform.
                            Ms. Jasmeet provided comprehensive demonstrations on
                            designing and customising visually engaging content.
                            The highly interactive session offered hands-on
                            practice, enabling teachers to implement their
                            learning immediately. Participants found the
                            workshop insightful, enriching, and instrumental in
                            enhancing digital classroom management. We extend
                            sincere gratitude to Ms. Jasmeet and the Adobe team
                            for this impactful and empowering session.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Adobe1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Adobe2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Adobe3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Adobe4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Adobe5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Adobe6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>

                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            CBSE District Level Deliberations on STEM Education
                          </h3>
                          <p>
                            "STEM is not just a curriculum; it is the language
                            of innovation, the spark of curiosity, and the
                            blueprint of tomorrow." Lotus Valley International
                            School, Noida Extension, proudly hosted the CBSE
                            District Level Deliberations on STEM Education on
                            5th July 2025 — a dynamic forum aimed at redefining
                            educational practices through STEM. The event
                            witnessed the convergence of educators,
                            policymakers, and scientific minds, sparking
                            dialogue around innovation, impact, and inclusive
                            teaching practices. The day commenced with a poetic
                            invocation, followed by a warm welcome to the
                            distinguished dignitaries. The Chief Guest, Mr.
                            Manoj Kumar Srivastava, Director (Training), CBSE,
                            delivered a thought-provoking keynote address,
                            sharing valuable insights on transforming classrooms
                            into spaces of inquiry, creativity, and
                            future-readiness. Gracing the occasion were Ms.
                            Poonam Sachdeva, Head, Centre of Excellence, Noida,
                            as the Guest of Honour, and esteemed judges
                            including Ms. Nidhi Kapoor, Vice Principal, Kothari
                            International School; Dr. Abhiruchi Passi,
                            Professor, Manav Rachna Innovation and Incubation
                            Centre; and Dr. Preeti Garg, Scientist-E, DRDO. Each
                            brought rich expertise from diverse academic and
                            research backgrounds, setting the tone for rigorous,
                            meaningful deliberations. The highlight of the event
                            was the series of presentations by 14 educator
                            teams, showcasing impactful STEM pedagogical
                            practices. Evaluated on parameters like innovation,
                            scalability, and relevance, each presentation
                            sparked discussion and inspired replication across
                            institutions. The deliberations proved to be a
                            meaningful step toward fostering a culture of
                            inquiry and collaboration in education. With each
                            presentation reflecting the passion and potential of
                            educators, the event reaffirmed the power of STEM to
                            not only solve real-world problems but also to
                            ignite curiosity and confidence in learners.
                            #STEMEducation #CBSEInitiative #InnovateToEducate
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM10.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM11.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM12.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM13.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM14.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM15.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM16.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM17.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM18.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/STEM19.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="trainermay-headingAgeCareer">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#trainermay-collapseAgeCareer"
                      aria-expanded="false"
                      aria-controls="trainermay-collapseAgeCareer"
                    >
                      June
                    </button>
                  </h2>
                  <div
                    id="trainermay-collapseAgeCareer"
                    class="accordion-collapse collapse"
                    aria-labelledby="trainermay-headingAgeCareer"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Building a Winner’s Attitude</h3>
                          <p>
                            “Winners are not those who never fail, but those who
                            never quit." - rightly said by Edwin Louis Cole. In
                            alignment with the school’s vision of nurturing
                            empowered educators and fostering a culture of
                            continuous professional growth, a session on the
                            theme ‘Building a Winner’s Attitude’ was conducted
                            on 26 June 2025. Two distinguished experts
                            facilitated the session - Ms. Mona Verma, acclaimed
                            author and Executive Presence Coach, and Mr. S.
                            Hali, an industry professional and leadership
                            trainer. The objective of the session was to instill
                            in educators a resilient mindset, strengthen
                            self-leadership, and reinforce the values of
                            perseverance, positivity and purpose in the academic
                            ecosystem. Ms. Mona Verma, an alumna of Lady Shri
                            Ram College and a Harvard Business School-certified
                            leadership coach, brought her multifaceted
                            experience to the fore. Through compelling
                            narratives and thought-provoking insights, she
                            emphasized the power of mindset, emotional
                            intelligence and authentic communication in shaping
                            a winner’s identity. Mr. S. Hali, with over 36 years
                            of experience in the power sector and leadership
                            roles at BHEL, brought a pragmatic and
                            action-oriented perspective to the session. His
                            inputs on strategic thinking, organisational
                            efficiency, and adaptive leadership were deeply
                            appreciated. Interactive activities, reflective
                            questions, and team exercises ensured high levels of
                            engagement and enthusiasm throughout the session.
                            Faculty members were encouraged to introspect,
                            collaborate, and translate the session’s takeaways
                            into their teaching practices. The programme
                            concluded with a warm vote of thanks, appreciating
                            the insightful contributions of the resource persons
                            and the steadfast support of the school leadership.
                            Overall, the training proved to be a meaningful step
                            towards personal growth and professional
                            development, reinforcing the belief that a winning
                            attitude is not just about achievement — it’s about
                            resilience, responsibility and the will to rise.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/may-2025-1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/may-2025-2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/(SQAAF)-CBSE Training Session/1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/may-2025-4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/may-2025-5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/may-2025-6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/may-2025-7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/may-2025-8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/may-2025-9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/may-2025-10.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/may-2025-11.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/may-2025-12.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/may-2025-13.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="posco-headingAgeCareer">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#posco-collapseAgeCareer"
                      aria-expanded="false"
                      aria-controls="posco-collapseAgeCareer"
                    >
                      May
                    </button>
                  </h2>
                  <div
                    id="posco-collapseAgeCareer"
                    class="accordion-collapse collapse"
                    aria-labelledby="posco-headingAgeCareer"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>CBSE CBP on Gender Sensitivity</h3>
                          <p>
                            "Gender preference does not define you. Your spirit
                            defines you." — P. C. Cast As part of CBSE’s ongoing
                            commitment to inclusive education, LVISNE hosted a
                            Capacity Building Program on Gender Sensitivity on
                            May 3, 2025. Conducted under the aegis of CBSE, the
                            workshop aimed to equip educators with the knowledge
                            and tools necessary to cultivate a more inclusive,
                            equitable school environment. Led by CBSE-empaneled
                            experts Ms. Indu Yadav(revered Principal,Lotus
                            Valley International School, Noida Extension) and
                            Ms. Aditi Roy(esteemed Principal,Mount Columbus
                            School, Delhi) the session delved into key themes
                            central to gender awareness and inclusive pedagogy.
                            Educators engaged in deconstructing traditional
                            gender constructs and identifying unconscious biases
                            that subtly shape classroom dynamics.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-11.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-12.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-13.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-14.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-15.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-16.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-17.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-18.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="posco-headingAgeCareer1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#posco-collapseAgeCareer1"
                      aria-expanded="false"
                      aria-controls="posco-collapseAgeCareer1"
                    >
                      April
                    </button>
                  </h2>
                  <div
                    id="posco-collapseAgeCareer1"
                    class="accordion-collapse collapse"
                    aria-labelledby="posco-headingAgeCareer1"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Teachers as Counsellors</h3>

                          <p>
                            ‘Teachers affect eternity; no one can tell where
                            their influence stops.’- Henry Adams Lotus Valley
                            International School, Noida Extension, aspires to
                            cultivate a teaching community that transcends
                            traditional roles, embracing the vital
                            responsibility of counsellors. In alignment with
                            this vision, the school organized an insightful
                            workshop on April 9, 2025, under the theme “Teachers
                            as Counsellors.” Led by the resource person, Ms.
                            Grisha Kharbanda, the workshop delved into the
                            prevalent concerns faced by adolescent students,
                            such as academic pressure, peer dynamics, identity
                            formation, family challenges, and emotional hurdles.
                            The session incorporated engaging hands-on
                            activities and interactive games designed to foster
                            trust and create a harmonious peer environment. The
                            educators thoroughly enjoyed the session, refining
                            their abilities in understanding developmental
                            stages, active listening, recognizing signs of
                            distress, encouraging open dialogue, and discerning
                            when to refer students for professional support.
                            This initiative underscores the school’s unwavering
                            commitment to not only nurturing the holistic growth
                            of students but also enhancing the professional
                            acumen of its facilitators.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <h3>Empowering Educators with Digital Tool</h3>
                          <p>
                            "Technology will never replace great teachers, but
                            in the hands of great teachers, it can be
                            transformational." — George Couros Lotus Valley
                            International School, Noida Extension, is committed
                            to fostering a teaching community that embraces
                            creativity and digital innovation. In line with this
                            vision, a workshop on integrating Adobe Express into
                            classroom teaching was organized in the school. The
                            session was led by Ms. Jasmeet Kaur Kang, Education
                            Evangelist at Adobe for Education India, who
                            provided valuable insights into utilizing digital
                            tools to enhance learning experiences. Ms. Kang
                            demonstrated features such as custom emoji creation
                            for collaborative learning and streamlined
                            assignment workflows, highlighting how these tools
                            can enhance classroom efficiency and student
                            engagement. These initiatives manifest the school's
                            unwavering dedication to nurturing learners'
                            creative potential through digital evolution.
                            #AdobeExpress#DigitalInnovation#EdTech#DigitalTransformation#TeacherEmpowerment#DigitalLiteracy#CreativePotential #LVISNE{" "}
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Counsellors-2025-10.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>

            <TabPanel>
              <div class="accordion accordion-flush" id="accordionFlushExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="posco-headingAgeCareer">
                    <button
                      class="accordion-button collapsed show"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#posco-collapseAgeCareer"
                      aria-expanded="false"
                      aria-controls="posco-collapseAgeCareer"
                    >
                      March
                    </button>
                  </h2>
                  <div
                    id="posco-collapseAgeCareer"
                    class="accordion-collapse collapse show"
                    aria-labelledby="posco-headingAgeCareer"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Report of Nature Nurture Workshop</h3>
                          <p>
                            “A good education is a foundation for a better
                            future.” – Elizabeth Warren
                          </p>
                          <p>
                            On 20th March, Lotus Valley International School,
                            Noida Extension, hosted an enriching training
                            session for the facilitators of Grades Nursery to
                            KG. The session was conducted in collaboration with
                            Nature Nurture, the school's esteemed curriculum
                            partner, and was led by resource persons Ms Shivani
                            Verma and Ms Baiza. The focus of the session was to
                            provide educators with a deeper understanding of
                            effective curriculum structuring, enabling them to
                            implement best practices in early childhood
                            education.
                          </p>
                          <p>
                            During the session, educators explored the Learning
                            Wheel and its six key components, while also
                            learning how to seamlessly integrate Maslow's
                            Hierarchy of Needs into lesson planning. The
                            significance of the Beginning Circle was
                            highlighted, followed by a structured walkthrough of
                            the Literacy, Numeracy, and other modules.
                            Additionally, a step-by-step demonstration on
                            accessing the curriculum portal enhanced the
                            educators' digital readiness.
                          </p>
                          <p>
                            To maintain an engaging atmosphere, invigorating
                            energizers were incorporated, ensuring an
                            interactive and lively experience. The educators
                            left the session feeling empowered, equipped with
                            innovative teaching strategies, and confident in
                            their ability to implement them effectively.
                          </p>
                          <p>
                            #lotusvalleynoidaextension #teachertraining
                            #innovativeteaching #foundationyears #naturenurture
                            #empowered
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/naturenuruture-mar1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/naturenuruture-mar2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/naturenuruture-mar3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/naturenuruture-mar4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/naturenuruture-mar5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/naturenuruture-mar6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/naturenuruture-mar7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/naturenuruture-mar8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/naturenuruture-mar9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/naturenuruture-mar10.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="posco-headingAgeCareer">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#posco-collapseAgeCareer"
                      aria-expanded="false"
                      aria-controls="posco-collapseAgeCareer"
                    >
                      February
                    </button>
                  </h2>
                  <div
                    id="posco-collapseAgeCareer"
                    class="accordion-collapse collapse"
                    aria-labelledby="posco-headingAgeCareer"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            Workshop on New-Age Career Options & Profile
                            Building
                          </h3>
                          <p>
                            Empowering Educators with Knowledge: Workshop on
                            New-Age Career Options & Profile Building
                          </p>
                          <p>
                            On February 19, 2025, Lotus Valley International
                            School, Noida Extension, had the privilege of
                            hosting an exclusive workshop for educators in
                            collaboration with Mr. Jitin Chawla’s Centre for
                            Career Development. The workshop, designed to
                            enhance educators' understanding of New-Age Career
                            Options and Profile Building, provided invaluable
                            insights on how teachers can help students navigate
                            their career paths and strengthen their university
                            applications. The session was divided into two key
                            segments. The first explored emerging career
                            opportunities across fields such as AI, Machine
                            Learning, Fintech, and Cyber Law, while the second
                            focused on profile-building strategies, including
                            the importance of internships, research, social
                            impact projects, and cultivating a strong digital
                            presence. Additionally, the workshop introduced
                            educators to top institutions offering specialized
                            courses and highlighted affordable international
                            study destinations with world-class education.
                            Through this collaborative effort with Mr. Jitin
                            Chawla, LVIS, NE continues to empower its educators
                            to guide students toward successful academic and
                            career journeys.
                          </p>
                          <p>
                            #careerguidance
                            #profilebuilding#careerdevelopment#teacherworkshops#newagecareers#educationforfuture#jitinchawla#EmpoweringEducators
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/newage1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/newage2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/newage3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/newage4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/newage5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/newage6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/newage7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="workshop1-25-heading">
                    <button
                      class="accordion-button "
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#workshop-1-25"
                      aria-expanded="false"
                      aria-controls="workshop-1-25"
                    >
                      January
                    </button>
                  </h2>
                  <div
                    id="workshop-1-25"
                    class="accordion-collapse collapse"
                    aria-labelledby="workshop1-25-heading"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Workshop on ‘Relationship Building</h3>
                          <p>
                            <b>
                              "Alone we can do so little; together we can do so
                              much." — Helen Keller
                            </b>
                          </p>
                          <p>
                            On Thursday, January 9, 2025, a workshop on 
                            <b>‘Relationship Building’</b> was held to
                            strengthen teacher connections and promote unity, in
                            line with Principal Ms. Indu Yadav’s vision of
                            fostering positive relationships as the foundation
                            for success within our school community.
                          </p>
                          <p>
                            The session was led by the esteemed Ms. Surjeet
                            Khanna, a respected educational leader and former
                            Founder Principal of DPS Greater Faridabad. With a
                            career rich in accomplishments, including the
                            Shiksha Bharat Ratan National Award and the AKS
                            Lifetime Achievement Award, Ms. Khanna shared
                            valuable insights on nurturing a collaborative and
                            empathetic school culture.
                          </p>
                          <p>
                            Teachers participated in engaging activities and
                            meaningful discussions, sharing strategies to build
                            stronger personal connections and foster a more
                            cohesive community. Ms. Khanna’s inspiring keynote
                            highlighted the importance of transparent
                            communication, mutual respect, and goal alignment to
                            create a nurturing learning environment.
                          </p>
                          <p>
                            The workshop concluded with heartfelt gratitude to
                            Ms. Khanna and a renewed commitment to teamwork as
                            the key to our collective success.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop25-1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop25-2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop25-3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop25-4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop25-5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop25-6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop25-7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop25-8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop25-9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop25-10.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop25-11.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="posco-headingFour">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#posco-collapseFour"
                      aria-expanded="false"
                      aria-controls="posco-collapseFour"
                    >
                      November
                    </button>
                  </h2>
                  <div
                    id="posco-collapseFour"
                    class="accordion-collapse collapse"
                    aria-labelledby="posco-headingFour"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            TWO-DAY TRAINING OF TRAINERS (TOT) CERTIFICATION
                            COURSE
                          </h3>
                          <p>
                            On 22nd and 23rd November 2024, Lotus Valley
                            International School, Noida Extension, hosted the
                            prestigious Training of Trainers (ToT) certification
                            programme, organised by the CBSE and designed by the
                            Institute of Secretariat Training and Management
                            (ISTM), Department of Personnel and Training (DoPT),
                            Government of India.{" "}
                          </p>
                          <p>
                            This transformative initiative for CBSE-nominated
                            resource persons featured an inaugural ceremony
                            graced by distinguished dignitaries: Dr. Ram
                            Shankar, Director, RO & COE, CBSE Dubai, UAE; Ms. S.
                            Dharini Arun, Joint Secretary, COE & Head, RO CBSE
                            Noida; Captain Yogendra Prakash Sharma - Additional
                            Director, ISTM; Mr. Tej Krishen Razdan, Resource
                            Person, ISTM & Ms. Indu Yadav, Principal, Lotus
                            Valley International School, Noida Extension, a
                            valued resource person. Their visionary addresses
                            emphasized the National Education Policy (NEP) 2020
                            and its role in fostering future-ready pedagogical
                            practices, while aligning educational standards with
                            India’s Vision 2047.
                          </p>
                          <p>
                            The programme encompassed foundational training
                            principles, leadership strategies, Training Needs
                            Analysis (TNA), and Design of Training (DOT),
                            coupled with dynamic interactive sessions and
                            collaborative activities. Participants gained
                            practical insights to elevate their professional
                            capacities and enhance educational quality in
                            alignment with NEP objectives. The event concluded
                            with a ceremonial closing, marked by heartfelt
                            gratitude to the dignitaries, resource persons, and
                            participants for their contributions. Reflections
                            shared during the programme underscored its impact,
                            and Lotus Valley International School, Noida
                            Extension received accolades for its impeccable
                            organisation coordination, exceptional hospitality,
                            and unwavering commitment to advancing educational
                            excellence.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tot_certificate1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tot_certificate2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tot_certificate3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tot_certificate4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tot_certificate5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tot_certificate6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tot_certificate7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tot_certificate8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tot_certificate9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tot_certificate10.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="posco-headingSep">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#posco-collapseSep"
                      aria-expanded="false"
                      aria-controls="posco-collapseSep"
                    >
                      September
                    </button>
                  </h2>
                  <div
                    id="posco-collapseSep"
                    class="accordion-collapse collapse"
                    aria-labelledby="posco-headingSep"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Empathy & Anti-Bullying Workshop</h3>
                          <p>
                            Understanding empathy and combating bullying are
                            crucial in our ongoing efforts to foster a positive
                            and respectful school environment. Our recent
                            workshop, led by Grade XI students under Senior
                            School Counsellor -Ms. Manika Pal's guidance tackled
                            these important topics head-on.
                          </p>
                          <p>
                            <b>Session Highlights:</b>
                          </p>
                          <p>
                            Positive Post-it Parade: Students shared and
                            celebrated positive qualities about each other and
                            themselves, fostering a sense of encouragement and
                            self-awareness.
                          </p>
                          <p>
                            Empathy Jar: Students reflected on recent acts of
                            empathy and contributed their thoughts to a
                            collective "Empathy Jar," emphasizing the value of
                            kindness.{" "}
                          </p>
                          <p>
                            Role-Playing Scenarios: students explored various
                            bullying scenarios through role plays, discussing
                            the impacts and reinforcing the importance of
                            empathy and standing up against bullying.
                          </p>
                          <p>
                            The session proved to be incredibly enriching,
                            offering valuable insights and fostering a stronger
                            sense of community among students.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/empthy1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/empthy2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="posco-headingThree">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#posco-collapseThree"
                      aria-expanded="false"
                      aria-controls="posco-collapseThree"
                    >
                      August
                    </button>
                  </h2>
                  <div
                    id="posco-collapseThree"
                    class="accordion-collapse collapse"
                    aria-labelledby="posco-headingThree"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Jodo Gyan Workshop </h3>
                          <p>
                            With the objective of making mathematics more
                            enjoyable through play-way curriculum and meaningful
                            explorations, the facilitators of Lotus Valley
                            International School, Noida Extension from Primary
                            wing, Ms Heenima Porwal, Ms Charu Garg and
                            Pre-Primary wing, Ms Nidhi Gupta and Ms Himani Rawat
                            attended a two-day workshop organized by the Jodo
                            Gyan team on 12 and 13 August, 2024 at Don Bosco
                            Technical Institute, Okhla.{" "}
                          </p>
                          <p>
                            The resource person Mr Shaji provided valuable
                            insights on implementing innovative methods to
                            transform abstract mathematical concepts into
                            concrete learning experiences. Activities such as
                            number games, group exercises, and puzzles were
                            showcased through the use of various manipulatives-
                            Ganitmala, Dice, Beads, Fraction Circles and Decimal
                            Blocks. The workshop was highly interactive and
                            provided practical insights into making mathematics
                            more engaging for the students.
                          </p>
                          <p>
                            #lvisne #jodogyan #mathfun #playwaycurriculum
                            #exploration #workshop
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Mathfun1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Mathfun2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Mathfun3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Mathfun4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="posco-headingSeven">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#posco-collapseSeven"
                      aria-expanded="false"
                      aria-controls="posco-collapseSeven"
                    >
                      July
                    </button>
                  </h2>
                  <div
                    id="posco-collapseSeven"
                    class="accordion-collapse collapse"
                    aria-labelledby="posco-headingSeven"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>CBSE Workshop</h3>
                          <p>
                            As a part of professional competency building and
                            empowerment programme, Ms Nidhi Jasrai and Ms Garima
                            Sinha Mathur from Lotus Valley International School,
                            Noida Extension attended a workshop on the topic
                            ‘Storytelling as Pedagogy’ on Saturday, 27 July
                            2024. The resource persons from CBSE, Ms Priyanka
                            Bhatkoti and Ms Sheyoli Gosh provided valuable
                            insights to enhance students’ engagement through art
                            of storytelling. They also highlighted the
                            significance and techniques to integrate
                            storytelling with different subjects and into
                            classroom practices, fostering more engaging and
                            effective learning environment.
                          </p>
                          <p>
                            #cbseworkshop #storytelling #pedagogy
                            #effectivelearning #studentengagement
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/cbseWork1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="posco-headingSix">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#posco-collapseSix"
                      aria-expanded="false"
                      aria-controls="posco-collapseSix"
                    >
                      May
                    </button>
                  </h2>
                  <div
                    id="posco-collapseSix"
                    class="accordion-collapse collapse"
                    aria-labelledby="posco-headingSix"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Gratitude & Respect</h3>
                          <p>
                            "Gratitude and respect, arise from acknowledging the
                            values in others and appreciating the positive
                            aspects of our own lives."{" "}
                          </p>
                          <p>
                            On May 24th, 2024, Ms Manika Pal, the senior school
                            counsellor, conducted a workshop for grade 9
                            students centred on the essential values- Gratitude
                            and Respect. The session delved into self-discovery,
                            adolescent changes, and evolving relationships with
                            self, family, teachers, and peers. Students engaged
                            in group discussions, followed by heartfelt
                            reflections on gratitude.
                          </p>
                          <p>
                            Transitioning to the next theme, they explored the
                            concept of respect, culminating in a positive
                            affirmation anthem, fostering a deeper understanding
                            of the significance of gratitude and respect.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/gratitude1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/gratitude2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/gratitude3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/gratitude4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/gratitude5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            ELEVATING PARENT WORKSHOP- CHILD WELL-BEING (GRADE
                            NURSERY)
                          </h3>
                          <p>
                            "Together, we can give our children the roots to
                            grow and the wings to fly."Jonas Salk
                          </p>
                          <p>
                            Lotus Valley International School, Noida Extension,
                            recently conducted a workshop on ‘Elevating Parent-
                            Child Well-Being: Empowered Parenting’ for Grade
                            Nursery on Saturday, 18 May 2024. This session
                            underscored the collaborative efforts required from
                            both school and parents to ensure the overall
                            development of our children.
                          </p>
                          <p>
                            The program commenced with a warm welcome from our
                            Head of Pre-Primary, Ms. Gagandeep Kaur, who
                            underscored the significant role children play in
                            our lives and the importance of positive parenting.
                            She emphasized the necessity of collaboration
                            between parents and school to foster the holistic
                            development of the child.
                          </p>
                          <p>
                            Following this, the school's counsellors, Ms Naisha
                            and Ms Shweta, took the stage to share valuable
                            insights and tips on nurturing a child's growth.
                            They discussed strategies for promoting well-rounded
                            development, highlighting that the combined efforts
                            of the school and parents are crucial for achieving
                            the best outcomes for our young learners.
                          </p>
                          <p>
                            #lvisne #empoweredparenting #holisticdevelopment
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/elevating1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/elevating2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/elevating3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/elevating4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/elevating5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/elevating6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/elevating7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/elevating8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/elevating9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>German - Max Mueller Bhavan</h3>
                          <p>
                            Exploring Germany: A Cultural Journey at Max Mueller
                            Bhavan”
                          </p>
                          <p>
                            On May 3, 2024, students of Grade VIII and IX had a
                            fantastic opportunity to dive deep into the German
                            language and culture! Through an engaging workshop
                            facilitated by the Goethe Institut/Max Mueller
                            Bhavan, our students delved into the dynamic world
                            of Germany, gaining first hand insights. Led by
                            Mr.Dünnwald, a native German speaker, the workshop
                            was packed with fun activities and interactive
                            sessions. From language practice to cultural
                            exchange, our students immersed themselves in a
                            truly enriching experience. Through engaging with
                            Mr. Dünnwald and participating in various
                            activities, our students not only honed their German
                            language skills but also gained a profound
                            understanding of intercultural communication.
                          </p>
                          <p>
                            They explored the fascinating cultural similarities
                            and differences between India and Germany, learning
                            to appreciate diversity in today's globalized world.
                          </p>
                          <p>
                            We are incredibly proud of our students for
                            embracing this opportunity with enthusiasm and
                            curiosity. Initiatives like this are instrumental in
                            shaping them into global citizens, ready to navigate
                            and thrive in an interconnected world.
                          </p>
                          <p>
                            Here's to more cultural exchanges and learning
                            adventures ahead!{" "}
                          </p>
                          <p>
                            #CulturalExchange #LanguageLearning
                            #GlobalCitizenship #LotusValleyInternationalSchool
                            Noida Extension#
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/German1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/German2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/German3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/German4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/German5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/German6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>

                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Teen Ties Strengthening the Parental Bond</h3>
                          <p>
                            "The bond between parent and teen is a delicate
                            dance of trust, understanding, and unconditional
                            love."
                          </p>
                          <p>
                            The workshop titled "Teen Ties: Strengthening the
                            Parental Bond" was organized under the aegis of our
                            principal and was spearheaded by Ms. Manika Pal,
                            Senior School Counselor.
                          </p>
                          <p>
                            The session delved into understanding the
                            complexities of the teenage mind, exploring the
                            reasons behind their behavior, addressing adolescent
                            concerns, sharing anecdotes from parents, and
                            incorporating engaging activities. Parents actively
                            participated throughout the session and expressed a
                            desire for the school to hold similar sessions on a
                            quarterly basis.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/teenTies1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/teenTies2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/teenTies3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/teenTies4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/teenTies5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="posco-headingOne">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#posco-collapseOne"
                      aria-expanded="false"
                      aria-controls="posco-collapseOne"
                    >
                      April
                    </button>
                  </h2>
                  <div
                    id="posco-collapseOne"
                    class="accordion-collapse collapse"
                    aria-labelledby="posco-headingOne"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            DENTAL CARE AND ORAL HYGIENE WORKSHOP-PRIMARY WING
                          </h3>
                          <p>
                            Lotus Valley International School, Noida Extension,
                            remains committed to cultivating an educational
                            atmosphere that places the well-being of its
                            students at the forefront. In alignment with this
                            ethos and as a crucial part of the 'World Health
                            Day' celebration, a 'Dental Care and Oral Hygiene’
                            workshop was organized for the learners of grade IV.
                            Dr. Suvidha Ghai Bhushan, a certified dentist,
                            served as the resource person, imparting invaluable
                            insights on optimal oral hygiene to our young
                            learners. During the workshop, students were
                            captivated to discover the significance of healthy
                            dietary habits, proper rinsing techniques, the
                            importance of flossing, and mastering effective
                            brushing methods and durations for ensuring oral
                            health and overall well-being. The session concluded
                            with the 'Toothie the Beaver' campaign and an
                            interactive quiz ‘How often’, where the
                            well-informed learners reflected upon the frequency
                            of oral care practices and the role of a balanced
                            diet in promoting good oral health. The workshop
                            concluded with a vote of appreciation from Ms.
                            Darshana Menon, the Head Primary, thanking Dr.
                            Suvidha Ghai for her valuable time and insightful
                            session.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/dentalCare1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/dentalCare2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/dentalCare3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/dentalCare4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/dentalCare5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/dentalCare6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/dentalCare7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>GRIHA COUNCIL WORKSHOP</h3>
                          <p>
                            "In a Seed of Hope and Action: Let's Make
                            Sustainability a Reality"
                          </p>
                          <p>
                            Lotus Valley International School, Noida Extension,
                            partnered with the GRIHA COUNCIL to host an SDG
                            workshop on Saturday, April 20, 2024. The workshop
                            aimed to equip facilitators with effective
                            sustainable practices, empowering them to integrate
                            awareness of Sustainable Development Goals (SDGs)
                            into classroom teachings and extend this knowledge
                            to the wider community.
                          </p>
                          <p>
                            Led by Ms. Shaily Mahera, the esteemed resource
                            person, the workshop cultivated a dynamic learning
                            environment. Through interactive group activities
                            such as 'Sustainbola' and 'Flash an Energy-Efficient
                            Sustainable Home Project,' facilitators gained
                            actionable strategies to promote sustainability and
                            environmental responsibility in their classrooms and
                            beyond.
                          </p>
                          <p>
                            The session proved enriching, inspiring all
                            participants to become mindful contributors to a
                            promising future. It underscored the significance of
                            collective action in attaining sustainability goals,
                            fostering a sense of responsibility and empowerment
                            among attendees.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/griha1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/griha2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/griha3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/griha4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/griha5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/griha6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/griha7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/griha8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>World Creativity and Innovation Day</h3>
                          <p>
                            “Equipping students with the toolkit of design
                            thinking can prepare them for a world that is
                            becoming more uncertain and ambiguous, and help them
                            effectively approach problems in an innovative and
                            efficacious manner that can be valuable for most
                            future endeavours.” -David Lee
                          </p>
                          <p>
                            At LVISNE, we firmly believe in igniting creativity
                            and fostering a culture of innovation among our
                            learners. A workshop was organized to celebrate
                            World Creativity and Innovation Day for the learners
                            of Grade VII on April 16, 2024. Renowned expert Dr.
                            K.J. George, with over three decades of experience
                            harmonizing academic and industrial perspectives,
                            spearheaded the event. Participants explored
                            innovative problem-solving methods with a focus on
                            empathy, creativity, and strategic thinking. Among
                            the challenges identified was the usability of
                            stylus devices for visually impaired individuals,
                            prompting students to propose inclusive solutions.
                            Dr. George's teachings deeply resonated, encouraging
                            participants to embrace user-centric design
                            principles. This workshop empowered attendees to
                            tackle complex challenges with adaptability and
                            originality, paving the way for a future of
                            innovation and sustainability. Through the lens of
                            design thinking, participants not only identified
                            problems but also actively engaged in crafting
                            solutions that catered to diverse needs and
                            perspectives.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/creativity1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/creativity2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/creativity3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/creativity4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/creativity5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            MENSTRUAL HEALTH AND HYGIENE WORKSHOP-PRIMARY WING
                          </h3>
                          <p>
                            Adolescence is a transformative phase, marking the
                            journey from childhood to adulthood, filled with
                            unique challenges and experiences. Recognizing the
                            significance of this transitional period, Lotus
                            Valley International School, Noida Extension, took a
                            proactive step by organizing a Menstrual Health and
                            Hygiene Awareness Workshop for grade V girls on
                            Friday, April 12 ,2024. Dr. Kanika Thakral, an
                            esteemed guest speaker, facilitated the session,
                            delving into crucial topics such as the physiology
                            of menstruation and the emotional and physical
                            changes associated with it. The workshop fostered an
                            open dialogue, with curious minds actively engaging
                            in a round of questions, all of which were
                            thoughtfully addressed, empowering the attendees
                            with knowledge and understanding in a fun and
                            memorable way.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/menstrual1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/menstrual2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/menstrual3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/menstrual4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>POCSO Workshop</h3>
                          <p>
                            A workshop on the POCSO Act – Protection of Children
                            against Sexual Offences was held for both teaching
                            and non-teaching staff on Monday, April 1, 2024 at
                            Lotus Valley International School, Noida Extension.
                            The workshop, conducted by experts Mr. Pradeep
                            Sharma and Ms. Janhavi Singh was a pivotal component
                            of project CACA (Children against Child Abuse),
                            dedicated to sensitizing participants to the vital
                            significance of the POCSO Act within the school
                            context.
                          </p>
                          <p>
                            The workshop equipped everyone with the necessary
                            awareness to identify signs of child abuse and the
                            understanding of concepts such as appropriate and
                            inappropriate touch. The staff members received
                            comprehensive insights into the legal framework
                            regarding steps to take when a child discloses such
                            experiences to us.{" "}
                          </p>
                          <p>
                            The session concentrated on clarifying the different
                            aspects of the act and emphasized the critical
                            importance of promptly reporting any cases of child
                            abuse.
                          </p>
                          <p>
                            #POCSOawareness #lvisne #educators #childrensafety
                            #childrights #safespace #wellbeing
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/posco-workshop1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/posco-workshop2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/posco-workshop3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/posco-workshop4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/posco-workshop5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/posco-workshop6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/posco-workshop7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/posco-workshop8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/posco-workshop9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div class="accordion accordion-fl" id="accordionflExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="posco-headingTwo">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#posco-collapseTwo"
                      aria-expanded="false"
                      aria-controls="posco-collapseTwo"
                    >
                      March
                    </button>
                  </h2>
                  <div
                    id="posco-collapseTwo"
                    class="accordion-collapse collapse"
                    aria-labelledby="posco-headingTwo"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            Workshop On New Education Policy (Pre-Primary Wing)
                          </h3>
                          <p>
                            The purpose of education is to make good human
                            beings with skill and expertise. Enlightened human
                            beings can be created by teachers.”- A.P.J. Abdul
                            Kalam
                          </p>
                          <p>
                            A workshop on New Education Policy 2020 was
                            conducted by the resource person Ms Chandeep Marwah
                            on Monday, 26 March 2024 for the Pre-Primary wing.
                            The objective of the workshop was to apprise the
                            facilitators about key principles of NEP and its
                            effective implementation. Ms Marwah elucidated the
                            importance of nurturing students’ cognitive
                            abilities and different ways to incorporate
                            innovating teaching pedagogies and multidisciplinary
                            approach using Blooms Taxonomy. She also shared
                            various strategies on blending competency based
                            teaching, integrating art and sports to foster
                            creativity, problem-solving skills and a lifelong
                            love for learning.{" "}
                          </p>
                          <p>
                            Overall, the workshop was very informative and
                            enlightening with lots of enjoyable and
                            brain-teasing activities to transform the overall
                            learning experiences of the students.
                          </p>
                          <p>
                            #lvisne #neweducationpolicy #nep2020
                            #multidisciplinary #bloomstaxonomy #competencybased
                            #artintegration
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NEP1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NEP2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NEP3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NEP4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NEP5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NEP6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NEP7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NEP8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NEP9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Brain Gym Workshop (Pre-Primary Wing)</h3>
                          <p>
                            A workshop was conducted by the school facilitators
                            Ms Nidhi Jasrai and Ms Garima Mathur on Brain Gym on
                            Saturday, 23 March 2024 for the Pre-Primary wing.
                            The session aimed to equip the teachers with
                            strategies on how to implement Brain Gym techniques
                            effectively to enhance cognitive development and
                            overall well-being of the students. The workshop
                            included a series of exercises such as Lazy Eight,
                            Brain Buttons, Thinking Cap, Cross Crawl etc. The
                            session provided valuable insights to the teachers
                            and motivated them to incorporate the concept of
                            Brain Gym in their regular classes to accelerate
                            learning and enhance students’ performance.
                          </p>
                          <p>
                            #braingym #lvisne #lazyeight #brainbuttons
                            #thinkingcap #crosscrawl #cognitivedevelopment
                            #wellbeing
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/braingym-1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/braingym-2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/braingym-3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/braingym-4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/braingym-5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/braingym-6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>NATURE NURTURE TRAINING (PRE-PRIMARY WING)</h3>
                          <p>
                            “Wisdom is not a product of schooling but of
                            lifelong attempt to acquire it”- Albert
                            Einstein{" "}
                          </p>
                          <p>
                            The Pre-Primary wing of Lotus Valley International
                            School, Noida Extension, in collaboration with its
                            curriculum partner NatureNurture, organized a
                            training session on Tuesday, 19.03.2024, focusing on
                            the "Integration of music and movement in
                            classrooms."{" "}
                          </p>
                          <p>
                            During the session, facilitators were equipped with
                            innovative strategies aimed at creating dynamic
                            learning environments. Engaging games such as drama
                            cake, music notation, fruit rhythm, and more were
                            introduced to the educators, empowering them with
                            cutting-edge methods for integrating music,
                            movement, and art into their teaching practices.
                          </p>
                          <p>
                            By providing educators with these tools and
                            techniques, Lotus Valley International School
                            reaffirmed its commitment to ensuring that its
                            faculty remains at the forefront of best practices
                            in education. This initiative not only enhances the
                            learning experience for students but also
                            underscores the school's proactive approach to
                            professional development and its focus on creating
                            well-rounded educational experiences.
                          </p>
                          <p>#learning #training #teacherstraining #LVISNE</p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/nature-pre-1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/nature-pre-2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/nature-pre-3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/nature-pre-4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/nature-pre-5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="posco-headingFive">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#posco-collapseFive"
                      aria-expanded="false"
                      aria-controls="posco-collapseFive"
                    >
                      January
                    </button>
                  </h2>
                  <div
                    id="posco-collapseFive"
                    class="accordion-collapse collapse"
                    aria-labelledby="posco-headingFive"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>NATURE NURTURE TRAINING</h3>
                          <p>
                            "Education is the kindling of a flame, not the
                            filling of a vessel." – Socrates
                          </p>
                          <p>
                            The Lotus Valley International School, Noida
                            Extension's kindergarten facilitators engaged in a
                            thorough training session on Monday, 9 January 2024.
                            Led by NatureNurture, the curriculum partners, the
                            session commenced with interactive warm-up
                            activities like the "Stop, Walk, Name & Clap" game
                            and "The Queen and Blindfold" team-building
                            exercise. The focus was on enhancing skills such as
                            listening, gross motor abilities, concentration,
                            leadership, and trust-building.
                          </p>
                          <p>
                            The resource person stressed the significance of
                            micro planning, fostering peer-to-peer learning, and
                            sharing best practices among educators. Tech
                            readiness, including the use of tools like Google
                            Drive and "Show What You Know" quizzes, was a key
                            aspect. Circle time demonstrations showcased the
                            integration of diverse domains, including health,
                            hygiene, and PSED.
                          </p>
                          <p>
                            Educators actively participated in the session,
                            concluding with reflections on their unique
                            takeaways, making the training both insightful and
                            interactive.
                          </p>
                          <p>
                            #trainingtheteachers #learning #LVISNE
                            #NatureNurture
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NatureNurture1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NatureNurture2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NatureNurture3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NatureNurture4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NatureNurture5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NatureNurture6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NatureNurture7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NatureNurture8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/NatureNurture9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            TEACHING THROUGH POWER OF SPORTS (NURSERY, GRADES I
                            & II)
                          </h3>
                          <p>
                            “Education builds the foundation and sports sculpt
                            the character.”
                          </p>
                          <p>
                            A workshop on ‘Teaching through Power of Sports’ was
                            organised for the facilitators of Pre-Primary wing
                            at Lotus Valley International School, Noida
                            Extension on Tuesday, 9 January 2024 by Ms Chandeep
                            Marwah, the resource person.{" "}
                          </p>
                          <p>
                            Ms Marwah highlighted the collaboration between the
                            UK, British Council, and CBSE leading to the
                            emergence of Physical Education Cards (PEC) in India
                            as a significant step towards promoting a more
                            structured approach to physical education. Keeping
                            the same in mind she engaged the facilitators in an
                            outdoor activity, Speed Dating, to help them
                            understand the importance of team building, decision
                            making and most importantly, creating a happy and
                            engaging environment. She took the facilitators on a
                            tour of the teachers’ manual highlighting the
                            importance of the pictorial cards and demonstrated
                            how sports can be integrated seamlessly into the
                            teaching methodology, fostering a holistic approach
                            to education.{" "}
                          </p>
                          <p>
                            Overall, the workshop served as a platform for
                            facilitators to recognize the significance of
                            physical well-being alongside academic excellence
                            into the daily routine of pre-primary education.
                          </p>
                          <p>
                            #PEC #powerofsports #holisticdevelopment #CBSE #NEP
                            #physicaldevelopment
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/TeachingSport1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/TeachingSport2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/TeachingSport3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/TeachingSport4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/TeachingSport5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/TeachingSport6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/TeachingSport7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/TeachingSport8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="accordionfthree">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#fl-headingThree"
                      aria-expanded="false"
                      aria-controls="fl-headingThree"
                    >
                      October
                    </button>
                  </h2>
                  <div
                    id="fl-headingThree"
                    class="accordion-collapse collapse"
                    aria-labelledby="fl-headingThree"
                    data-bs-parent="#accordionfthree"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Nurturing the Nurturer - workshop</h3>
                          <p>
                            The workshop started by encouraging teachers to
                            embrace themselves and recite affirmations.
                          </p>
                          <p>
                            As the session progressed, teachers were invited to
                            reflect on their "jar of worries" and their "moments
                            of happiness." A few teachers eagerly opened up
                            about their personal struggles, which inspired
                            others to share their own life journeys.
                          </p>
                          <p>
                            The discussion then shifted towards the topic of
                            mental health and how often we tend to overlook it,
                            choosing instead to seek help from spiritual healers
                            or pandits rather than from any certified mental
                            health professionals. The teachers candidly shared
                            amusing anecdotes about their experiences in this
                            regard.
                          </p>
                          <p>
                            The workshop concluded on a heartfelt note,
                            emphasizing the importance of prioritizing self-care
                            and mental well-being above all else.
                          </p>
                          <p>
                            Towards the conclusion of the workshop, the story of
                            the legendary Sindbad the Sailor was shared,
                            highlighting his fearless and daring voyages.
                            Sindbad's unwavering belief in his dreams and his
                            refusal to give up served as an inspiring example.
                          </p>
                          <p>
                            Following the story, the teachers came together to
                            celebrate with a victory dance, with some even
                            singing along. The participants took away a valuable
                            lesson from Sindbad's story, learning to apply his
                            resilience and determination to face challenges in
                            their own lives.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Nurturing-1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Nurturing-2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Nurturing-3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Nurturing-4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>CBSE WORKSHOP (COE DELHI)</h3>
                          <p>
                            Ms. Darshana Menon, Primary Wing Coordinator and Ms.
                            Nidhi Jasrai from Lotus Valley International School,
                            Noida Extension attended a workshop on ‘Capacity
                            Building for Foundational Educators and Impact
                            Leaders’ which was held on Wednesday, 4th October
                            2023 at CBSE, COE Delhi, East Patparganj. It was
                            conducted by the resource person, Ms. Sonia Relia,
                            on the elements of creating effective engagement
                            environment for the learners through activity based
                            teaching. She emphasized on competency based
                            teaching through creative resources and interactive
                            theme boards. Highlighting enhancement of the
                            reading skills of leaners, Ms. Relia shared
                            techniques to improve phonic awareness using the
                            folk tools of India with storytelling. It was an
                            enriching and informative session that empowered
                            everyone present with effective strategies to foster
                            quality learning.
                          </p>
                          <p>
                            #lvisne #competencybasedteaching #creativeresources
                            #CBSEworkshop #capacitybuilding
                            #activitybasedteaching
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/codeDelhi-1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/codeDelhi-2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/codeDelhi-3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="fl1-headingOne">
                    {/* <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#fl-headingOne" aria-expanded="false" aria-controls="fl-headingOne"> */}
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#F1-collapseOne"
                      aria-expanded="false"
                      aria-controls="F1-collapseOne"
                    >
                      May
                    </button>
                  </h2>
                  {/* <div id="fl-headingOne" class="accordion-collapse collapse" aria-labelledby="fl-headingOne" data-bs-parent="#accordionflExample"> */}
                  {/* <div id="fl1-headingOne" class="accordion-collapse collapse" aria-labelledby="fl1-headingOne" */}
                  <div
                    id="F1-collapseOne"
                    class="accordion-collapse collapse"
                    aria-labelledby="fl1-headingOne"
                    data-bs-parent="#accordionflExample"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Financial Literacy</h3>
                          <p>
                            <i>
                              “An investment in financial knowledge, pays the
                              best interest”
                            </i>
                          </p>
                          <p>
                            The workshop was led by renowned resource person,
                            Mr. Anil Saxena, qualified CA , who has extensive
                            expertise in the field of finance and owns a
                            platform called R K Wealth with a purpose to guide
                            small investors .
                          </p>
                          <p>
                            The workshop commenced with the explaining of
                            concept like Investment, budgeting and savings and
                            their working principles. He focused on NPS, a
                            voluntary pension scheme launched by the Indian
                            government. Teachers gained insights into the
                            different investment options available within the
                            NPS framework and the long-term retirement planning
                            benefits it offers.
                          </p>
                          <p>
                            He also introduced mutual funds and elaborated on
                            their structure, types, and benefits and the
                            importance of diversification. They were also
                            briefed on the different categories of mutual funds
                            and the risk-return trade-off associated with each.
                          </p>
                          <p>
                            The final session focused on SIP, a disciplined
                            investment approach that allows individuals to
                            invest regularly in mutual funds. Participants
                            gained insights into how SIPs can help in achieving
                            long-term financial goals and creating wealth over
                            time.
                          </p>
                          <p>
                            The financial literacy workshop conducted by the
                            resource person proved to be a valuable learning
                            experience for the teachers at Lotus Valley
                            International School Noida Extension. The workshop's
                            success in enhancing financial literacy among
                            educators will undoubtedly enable them to impart
                            valuable financial knowledge to their students,
                            empowering the younger generation to develop sound
                            financial habits.
                          </p>
                          <p>
                            The workshop concluded with closing remarks from Mr.
                            Saxena, expressing his gratitude to the participants
                            for their active participation and enthusiasm. The
                            attendees were encouraged to provide feedback on the
                            workshop's content, organization, and overall
                            effectiveness.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fl1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fl2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fl3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fl4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fl5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fl6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fl7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fl8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fl9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Workshop On Fitness</h3>
                          <p>
                            The workshop on mindfulness, nutrition, and overall
                            health for teachers was conducted by Ms. Kompal Gaur
                            on Monday, 22.05.2023 for the teachers with the aim
                            of enhancing their awareness and understanding of
                            these essential topics. The workshop provided
                            valuable insights into the benefits of mindfulness
                            practices, the significance of proper nutrition, and
                            overall health promotion strategies.
                          </p>
                          <p>
                            The workshop began with a warm welcome and
                            introduction to the topics that would be covered
                            throughout the session. The resource person,
                            Ms.Kompal briefly outlined the importance of
                            mindfulness, nutrition, and overall health for
                            teachers and their impact on both personal
                            well-being and professional effectiveness.
                          </p>

                          <p>
                            <b>Mindfulness:</b>
                          </p>
                          <p>
                            An expert in mindfulness conducted a session on the
                            fundamentals of mindfulness and its relevance.
                          </p>
                          <p>
                            Participants engaged in various mindfulness
                            exercises, including breathing techniques, body
                            scans, and guided meditations.
                          </p>
                          <p>
                            The facilitator explained how incorporating
                            mindfulness practices into daily routines can reduce
                            stress, improve focus and attention, and enhance
                            overall emotional well-being.
                          </p>

                          <p>
                            <b>Importance of Nutrition:</b>
                          </p>
                          <p>
                            She further spoke about the significance of proper
                            nutrition for teachers and its impact on cognitive
                            function, energy levels, and overall health.
                          </p>
                          <p>
                            The session covered topics such as balanced meal
                            planning the role of overall exercise.
                          </p>
                          <p>
                            Interactive discussions and Q&A sessions allowed
                            participants to clarify doubts and gain practical
                            tips for incorporating healthy workoout habits into
                            their busy schedules.
                          </p>

                          <p>
                            <b>Strategies for Overall Health Promotion:</b>
                          </p>
                          <p>
                            This session focused on holistic health approaches,
                            encompassing physical, mental, and emotional
                            well-being.
                          </p>
                          <p>
                            The resource person discussed the importance of
                            regular exercise, adequate sleep, stress management
                            techniques, and fostering positive relationships.
                          </p>
                          <p>
                            Participants were encouraged to develop personalized
                            well-being plans, setting realistic goals for
                            improving their overall health and implementing
                            self-care practices.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fit1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fit2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fit3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fit4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fit5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fit6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/fit7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div
                class="accordion accordion-unique"
                id="accordionuniqueExample"
              >
                <div class="accordion-item">
                  <h2 class="accordion-header" id="uniqueMar-headingOne1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#uniqueMar-headingOne"
                      aria-expanded="false"
                      aria-controls="uniqueMar-headingOne"
                    >
                      March
                    </button>
                  </h2>
                  <div
                    id="uniqueMar-headingOne"
                    class="accordion-collapse collapse"
                    aria-labelledby="uniqueMar-headingOne1"
                    data-bs-parent="#accordionuniqueExample"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>TEACHERS TRAINING – TRANSITION (KINDERGARTEN)</h3>
                          <p>
                            “Education is the passport for the future for
                            tomorrow belongs to those who prepare for it
                            today!’- Malcolm X{" "}
                          </p>
                          <p>
                            To empower and equip the facilitators of
                            kindergarten during the initial days of transition
                            of our learners Lotus Valley International School,
                            Noida Extension in partnership with NatureNurture,
                            conducted a session on Monday, 20th March, 2023.
                          </p>
                          <p>
                            The resource, Ms. Shreya Singh and Ms. Geeta, guided
                            the facilitators through the early days of
                            transitioning of young learners to help foster a
                            close relationship between the learners and the
                            facilitators. They emphasized the NatureNurture
                            learning cycle, from planning for a new session to
                            reflecting on and reviewing the entire process. They
                            recommended a variety of energizing and
                            team-building activities that could be used in
                            classrooms to make learning interesting. The
                            training session gave the facilitators the
                            opportunity to review their instructional
                            techniques, prepare for the exercise, and be
                            inspired to put the activities into practice in
                            their teaching-learning methods.
                          </p>
                          <p>
                            #LVISNE #learingandfun #teacherstraining #transition
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tt-transition-1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tt-transition-2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tt-transition-3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tt-transition-4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>SEED TO PLANT WORKSHOP (PRE-PRIMARY WING)</h3>
                          <p>
                            “You can teach a student a lesson for a day, but if
                            you can teach him to learn by creating curiosity, he
                            will continue the learning process as long as he
                            lives.”
                          </p>
                          <p>
                            With a vision to design a constructive and
                            meaningful teaching-learning environment for the
                            holistic development of learners, an ice-breaking
                            workshop by Ms Chandeep Marwah, from Seed to Plant
                            Foundation was organized for the facilitators of
                            Pre-Primary wing of Lotus Valley International
                            School, Noida Extension on Monday, 20th March 2023.
                          </p>
                          <p>
                            The purpose of the session was to highlight the
                            importance of thematic and integrated learning,
                            thereby focusing on maximizing the inherent
                            potential of learners and equipping them with the
                            important skills of the 21st century like Language
                            Development, Cognitive Development, Fine and Gross
                            Motor Skills, Interpersonal skills, etc. Ms Chandeep
                            Marwah, emphasized on identifying the varying
                            degrees of intellectual abilities within a
                            classroom, thereby catering to individual needs. It
                            was an interactive session which enabled
                            facilitators to explore different books and teaching
                            techniques provided by our esteemed curriculum
                            partner, Seed to Plant Foundation.{" "}
                          </p>
                          <p>
                            #lvisne #teachers #curriculum #teachertraining
                            #curiosity #integratedapproach
                            #intellectualabilities #21stcenturyskills
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/plantSeed-1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/plantSeed-2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/plantSeed-3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/plantSeed-4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/plantSeed-5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/plantSeed-6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="unique-headingOne1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#unique-headingOne"
                      aria-expanded="false"
                      aria-controls="unique-headingOne"
                    >
                      November
                    </button>
                  </h2>
                  <div
                    id="unique-headingOne"
                    class="accordion-collapse collapse"
                    aria-labelledby="unique-headingOne1"
                    data-bs-parent="#accordionuniqueExample"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Unique Undergraduate Courses Workshop</h3>
                          <p>
                            A workshop on Unique Undergraduate Courses was
                            organized for the students of grade-11, to make them
                            more aware about the combinations of courses
                            available, nationally and internationally. The
                            resource person- Mr. Ritesh Jain from Pratham- Lead
                            the Way, was warmly welcomed, and was handed over a
                            sapling by the respected coordinator- Ms. Sheetal
                            Mittal.
                          </p>
                          <p>
                            He apprised the students about the purpose of
                            profile building, and recommended them to create an
                            extended portrait of themselves; for an easy
                            admission procedure. The session majorly threw a
                            light on;{" "}
                          </p>
                          <p>
                            various facets of different offbeat careers that are
                            in demand, these days. He further discussed in
                            detail,the unique combinations of subjects; offered
                            in several universities; National- Ashoka
                            University, Delhi University, Flames University,
                            Gujrat National Law University, Indian Statistical
                            Institute, Palaksha University, and International-
                            Ecole Polytechnique, Harvard University, Kings
                            College, Oxford{" "}
                          </p>
                          <p>
                            University, University of Sydney, Waterloo
                            University.{" "}
                          </p>
                          <p>
                            He also discussed various competitive exams and
                            scholarships that the students can appear in, and
                            their eligibility criteria.{" "}
                          </p>
                          <p>
                            The workshop was indeed an interactive one, and was
                            concluded with the question and answers round. It
                            was indeed an enriching experience, for all the
                            students.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Undergraduate1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Undergraduate2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/Undergraduate3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="unique-headingThree3">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#unique-headingThree"
                      aria-expanded="false"
                      aria-controls="unique-headingThree"
                    >
                      September
                    </button>
                  </h2>
                  <div
                    id="unique-headingThree"
                    class="accordion-collapse collapse"
                    aria-labelledby="unique-headingThree3"
                    data-bs-parent="#unique-headingThree"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Effective Classroom Management</h3>
                          <p>
                            An online workshop on the topic ‘Effective Classroom
                            Management’ was conducted by the counsellors- Ms.
                            Shivani Seth and Ms. Srishti Bhola on 13.09.2022 for
                            the educators of grades 6 to 11. The topic was
                            introduced by Ms. Shivani Seth, and then the
                            platform was handed over to Ms. Srishti Bhola, who
                            started by discussing what makes a great teacher.
                            The audience was asked to think of the greatest
                            teacher; they ever had and elaborate on his/her
                            attributes that made her great. Teachers
                            participated and found the question interesting. The
                            features of an effective classroom were then
                            discussed. Ms. Shivani Seth; then elaborated upon
                            the strategies for classroom management in specific
                            domains like handling inattention, inappropriate
                            behaviour, hyperactivity, and establishing effective
                            communication. For each of the domain discussed,
                            different case scenarios were shared, and the
                            teachers were asked to come up with solutions. The
                            feedback from the teachers was highly insightful and
                            creative.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/effective-1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/effective-2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/effective-3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/effective-4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/effective-4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div class="accordion accordion-flush" id="accordionFlushExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingtt">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapsett"
                      aria-expanded="false"
                      aria-controls="flush-collapsett"
                    >
                      March
                    </button>
                  </h2>
                  <div
                    id="flush-collapsett"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingtt"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>Teachers Training(Pre-Primary Wing)</h3>
                          <p>
                            “Curriculum should help children make a deeper
                            understanding of their own experiences.”{" "}
                          </p>
                          <p>
                            LVIS believes in continuously upgrading the skills
                            of its facilitators. Thus, a virtual curriculum
                            induction was organized for the facilitators of
                            Lotus Valley International School, Noida Extension
                            by Ms Anuradha Sinha, curriculum partner for Grades
                            I & II on Wednesday, 16 March 2022.
                          </p>
                          <p>
                            The purpose of the session was to highlight the
                            importance of thematic and integrated learning,
                            thereby focusing on the important elements of
                            education for learners like Language Development,
                            Cognitive Development, Fine and Gross Motor Skills,
                            and Bloom’s Taxonomy etc. Ms Anuradha,
                            constructively guided the facilitators with the
                            steps to enhance the reading skills of learners at
                            initial stages. She emphasized on the technique of
                            ‘See, Think and Wonder’ in order to promote the
                            creative thinking of young explorers. In addition, a
                            few dynamic solutions to routine learning problems
                            of classrooms were also discussed.
                          </p>
                          <p>
                            Towards the end of the session, facilitators got an
                            opportunity to share their valuable insights to the
                            curriculum and highlight the core areas of
                            improvement. It was an interactive session which
                            enabled facilitators to explore different books and
                            teaching techniques provided by esteemed curriculum
                            partner, Ms Anuradha.
                          </p>
                          <p>
                            #lvisne #teachers #curriculum #teaching #training
                            #cognitivedevelopment #creativethinking
                            #languagedevelopment #integratedapproach
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tt-pp-1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tt-pp-2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tt-pp-3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tt-pp-4.png"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/tt-pp-5.png"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingSix">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseSix"
                      aria-expanded="false"
                      aria-controls="flush-collapseSix"
                    >
                      September
                    </button>
                  </h2>
                  <div
                    id="flush-collapseSix"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingSix"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <div className="row pdf_sec">
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <Link
                              to="https://webapi.entab.info/api/image/LVISGN/public/pdf/Training-Data-september-activity.pdf"
                              target="_blank"
                            >
                              <LazyLoad>
                               
                                <img
                                  src="https://webapi.entab.info/api/image/LVISGN/public/Images/circular.png"
                                  className="img-fluid"
                                  alt="Lotus Valley International School, Greater Noida"
                                />
                              </LazyLoad>
                              <h5>September </h5>
                              Activity
                            </Link>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <Link
                              to="https://webapi.entab.info/api/image/LVISGN/public/pdf/Training-Data-september-nur-II.pdf"
                              target="_blank"
                            >
                              <LazyLoad>
                               
                                <img
                                  src="https://webapi.entab.info/api/image/LVISGN/public/Images/circular.png"
                                  className="img-fluid"
                                  alt="Lotus Valley International School, Greater Noida"
                                />
                              </LazyLoad>
                              <h5>September </h5>
                              Class Pre Nur - II
                            </Link>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <Link
                              to="https://webapi.entab.info/api/image/LVISGN/public/pdf/Training-Data-september-III-X.pdf"
                              target="_blank"
                            >
                              <LazyLoad>
                               
                                <img
                                  src="https://webapi.entab.info/api/image/LVISGN/public/Images/circular.png"
                                  className="img-fluid"
                                  alt="Lotus Valley International School, Greater Noida"
                                />
                              </LazyLoad>
                              <h5>September </h5>
                              Class III - X
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingFive">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFive"
                      aria-expanded="false"
                      aria-controls="flush-collapseFive"
                    >
                      August
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFive"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingFive"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <div className="row pdf_sec">
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <Link
                              to="https://webapi.entab.info/api/image/LVISGN/public/pdf/Training-Data-August-activity.pdf"
                              target="_blank"
                            >
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/circular.png"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                              <h5>August </h5> Activity
                            </Link>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <Link
                              to="https://webapi.entab.info/api/image/LVISGN/public/pdf/Training-Data-August-nur-II.pdf"
                              target="_blank"
                            >
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/circular.png"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                              <h5>August </h5> Class Pre Nur - II
                            </Link>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <Link
                              to="https://webapi.entab.info/api/image/LVISGN/public/pdf/Training-Data-August-III-X.pdf"
                              target="_blank"
                            >
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/circular.png"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                              <h5>August </h5> Class III - X
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingFour">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFour"
                      aria-expanded="false"
                      aria-controls="flush-collapseFour"
                    >
                      July
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFour"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingFour"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <div className="row pdf_sec">
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <Link
                              to="https://webapi.entab.info/api/image/LVISGN/public/pdf/Training-Data-july-activity.pdf"
                              target="_blank"
                            >
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/circular.png"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                              <h5>July </h5> Activity
                            </Link>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <Link
                              to="https://webapi.entab.info/api/image/LVISGN/public/pdf/Training-Data-july-nur-II.pdf"
                              target="_blank"
                            >
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/circular.png"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                              <h5>July </h5> Class Pre Nur - II
                            </Link>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <Link
                              to="https://webapi.entab.info/api/image/LVISGN/public/pdf/Training-Data-july-III-X.pdf"
                              target="_blank"
                            >
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/circular.png"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                              <h5>July </h5> Class III - X
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingThree">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                    >
                      June
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingThree"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <div className="row pdf_sec">
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <Link
                              to="https://webapi.entab.info/api/image/LVISGN/public/pdf/Training-Data-june-activity.pdf"
                              target="_blank"
                            >
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/circular.png"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                              <h5>June </h5> Activity
                            </Link>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <Link
                              to="https://webapi.entab.info/api/image/LVISGN/public/pdf/Training-Data-june-nur-II.pdf"
                              target="_blank"
                            >
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/circular.png"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                              <h5>June </h5> Class Pre Nur - II
                            </Link>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <Link
                              to="https://webapi.entab.info/api/image/LVISGN/public/pdf/Training-Data-june-III-X.pdf"
                              target="_blank"
                            >
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/circular.png"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                              <h5>June </h5> Class III - X
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingTwo">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                    >
                      May
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingTwo"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <div className="row pdf_sec">
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <Link
                              to="https://webapi.entab.info/api/image/LVISGN/public/pdf/FEEDBACK-MAY-2021.pdf.pdf"
                              target="_blank"
                            >
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/circular.png"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                              <h5>May </h5> Activity
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingOne">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne"
                    >
                      April
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingOne"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <div className="row pdf_sec">
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <Link
                              to="https://webapi.entab.info/api/image/LVISGN/public/pdf/FEEDBACK-APRIL-2021.pdf.pdf"
                              target="_blank"
                            >
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/circular.png"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                              <h5>April </h5> Activity
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div class="accordion accordion-flush" id="accordionFlushExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="twentyone-headingSep">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#twentyone-collapseSep"
                      aria-expanded="false"
                      aria-controls="twentyone-collapseSep"
                    >
                      February
                    </button>
                  </h2>
                  <div
                    id="twentyone-collapseSep"
                    class="accordion-collapse collapse"
                    aria-labelledby="twentyone-headingSep"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>GSP- Block Printing</h3>
                          <p>
                            ‘Culture is the widening of the mind and of the
                            spirit’
                          </p>
                          <p>
                            We, at Lotus Valley International School, NE,
                            believe in giving an exciting and multifaceted
                            dimension to the learning of Social Science. In our
                            endeavour to inculcate in young minds a sense of
                            pride for our heritage, a live workshop on ‘Block
                            Printing’ was conducted for students of grade V by
                            the founder of Amoha Prints, Ms. Pooja Gokul on 4
                            February 2021, Thursday. Our country’s heritage
                            speaks volumes about the rich, diverse handicrafts
                            ranging from puppetry to block printing. The session
                            was conducted as part of the Dharohar Week to
                            celebrate the art of different parts of the country
                            which would help in developing children into
                            sensitive, responsible and progressive citizens of
                            the society, caring for the past so as to create a
                            better future for tomorrow.
                          </p>
                          <p>
                            The workshop helped the students to understand block
                            printing as a dynamic art form by creating visually
                            appealing images on cloth. To familiarise the
                            learners with the technique of block printing, Ms.
                            Pooja Gokul demonstrated and equipped the young
                            enthusiasts with innovative patterns and designs.
                            This interactive workshop brought home the pioneer
                            art of Gujarat and Rajasthan to the learners and
                            widened the horizon of skilful learning. It was
                            indeed heartwarming to see Lotusians bring the magic
                            of the land alive. Students enjoyed creating
                            colourful geometrical and floral designs and
                            gracefully showcased their intricate work on
                            different fabrics. It became a collaborative
                            platform for celebrating the rich heritage of India
                            for all.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/gsp1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/gsp2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/gsp3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/gsp4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/gsp5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/gsp6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/gsp7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/gsp8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/gsp9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>HERITAGE FAIR - (III – IX)</h3>
                          <p>
                            “As the soil however rich it may be, cannot be
                            productive without cultivation so the mind without
                            culture can never produce good fruit.”
                          </p>
                          <p>
                            In our endeavour to create awareness and a sense of
                            belonging among youth and inculcate in young minds a
                            feeling and a sense of pride for our heritage, the
                            Social Science Department organized the Heritage
                            Fair – ‘Dharohar’ from 3 to 5 February 2021. The
                            students were provided with opportunities through
                            live workshops, virtual tour walks and activities to
                            understand, value and preserve the rich legacy of
                            our diverse culture. They were engaged in a plethora
                            of exciting activities and engaging live workshops
                            by artisans/guest speakers from different parts of
                            the country which helped in developing them into
                            sensitive, responsible and progressive citizens of
                            the society, caring for the past so as to create a
                            better future for tomorrow.
                          </p>
                          <p>
                            The week commenced with virtual tour for grades III
                            – IX. The tours included Sarkhej Roza, Gujarat,
                            Humanyu’s Tomb Trail – Delhi, Adalaj Vav, Gujarat,
                            Park Street and College Street – Kolkata, Qutub
                            Minar, and the Red Fort, Delhi respectively. Each of
                            the virtual tour was then followed by reflection
                            activity using online tool dotstroming, wherein
                            students wrote their takeaways from the walks.
                            Following the virtual tours, on the second day, a
                            plethora of activities based on different themes for
                            each class were conducted. Starting with grade III
                            ‘Puppetry as Heritage’ students applied their
                            creative thinking skills by making hands-on puppets
                            and understood puppetry as a dynamic art form. Grade
                            IV ‘Coconut Shell Craft – Intangible Cultural
                            Heritage’ students created interesting pieces of art
                            form and were able to appreciate coconut shells used
                            in our handicraft industry. Grade V ‘Print and
                            Pattern – Block Printing by Ms Pooja Gokul’ wherein
                            students created visually appealing images on cloth
                            and gained confidence in this skill, they were able
                            to understand the value and beauty of handmade
                            sustainable products and develop sensitivity towards
                            the environment. Grade VI ‘Live Pottery Making
                            Workshop by Ms Pooja Verma’ wherein students
                            understood the basic vocabulary and techniques
                            involved in pottery making both traditional and
                            contemporary through hands-on experience. Grade VII
                            ‘Lost Cuisine of India – Traditional Potluck’
                            wherein students researched and prepared a lost
                            recipe and presented it among their peers in order
                            to revive, discover, value and preserve the rich
                            heritage of our composite food culture which was
                            then followed by a potluck with their class
                            teachers. Grade VIII ‘Reinvent the traditional
                            Textile Arts of India’ wherein students were able to
                            appreciate a deeper understanding and sensitivity
                            towards the traditional textile arts of India and
                            develop responsibility within themselves for a
                            sustainable approach to modern living. Grade IX
                            ‘Adopt a Monument Scheme – Preserving the Past for
                            the Future’ wherein students were able to understand
                            the significance and relevance of historical
                            monuments in our lives and devised ways of
                            preserving and protecting them for future by
                            creating raps, live campaigns and slogans. The fair
                            culminated with a grand finale through an
                            interactive student-parent quiz on Kahoot.it.
                          </p>
                          <p>
                            Parents enthusiastically participated in the quiz
                            which was based on virtual tours, padlet discussions
                            and activities done throughout the week. Parents
                            appreciated the efforts of the school in making the
                            Heritage Fair Week fun and engaging for their
                            children and for them as well, taking them back to
                            their school days.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/haritage1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/haritage2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/haritage3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/haritage4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/haritage5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/haritage6.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/haritage7.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/haritage8.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/haritage9.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/haritage10.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="twentyone-headingFour">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#twentyone-collapseFour"
                      aria-expanded="false"
                      aria-controls="twentyone-collapseFour"
                    >
                      December
                    </button>
                  </h2>
                  <div
                    id="twentyone-collapseFour"
                    class="accordion-collapse collapse"
                    aria-labelledby="twentyone-headingFour"
                  >
                    <div class="accordion-body">
                      <div className="row training_img">
                        <div className="col-lg-12">
                          <h3>
                            Guest Speaker Programme -Grade I – Good Touch Bad
                            Touch
                          </h3>
                          <p>
                            “Wisdom is giving children their wings,
                            <br />
                            along with the rudder of awareness
                            <br />
                            to keep them safe from prying hands.”
                          </p>
                          <p>
                            Safety and security of learners is a sensitive, and
                            crucial aspect of growing up years and it requires
                            give paramount importance and attention. Keeping
                            this in view, a virtual Guest Speaker Programme on
                            ‘Good Touch Bad Touch’ was conducted for Grade I by
                            guest speaker Dr Kanika Thakral, a gynaecologist by
                            profession, on Saturday, 28 November 2020.{" "}
                          </p>
                          <p>
                            The session commenced with a warm welcome extended
                            to the guest speaker by the Principal, Ms Indu
                            Yadav. The difference between good and bad touch was
                            well explained to the learners using an age
                            appropriate presentation. The interactive workshop
                            also dwelled on the urgent need to empower young
                            children and to report mal-intentions experienced by
                            the learners at any point of time with adults in
                            their safe circles without fear or guilt. They were
                            encouraged to confide about their problems with
                            their parents and teachers. The presenter also
                            reiterated the learning points with the help of a
                            video. Learners were presented with different
                            situations where they had to decide whether it was a
                            safe touch or an unsafe touch, thus assessing the
                            learners grasp of this pertinent topic.
                          </p>
                          <p>
                            The easy to understand presentation motivated the
                            learners to think, ponder and question. Interesting
                            questions were put up by the learners which the
                            resource person resolved tactfully. This was surely
                            an enriching experience for the learners, as they
                            were receptive and engaged throughout.{" "}
                          </p>
                          <p>
                            The session culminated with a vote of thanks by the
                            Pre-Primary Coordinator Ms Gagandeep Kaur, as she
                            appreciated Dr Kanika Thakral on the successful
                            session.
                          </p>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/guestSpeaker1.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/guestSpeaker2.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/guestSpeaker3.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/guestSpeaker4.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="box">
                            <LazyLoad>
                             
                              <img
                                src="https://webapi.entab.info/api/image/LVISGN/public/Images/guestSpeaker5.jpg"
                                className="img-fluid"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div
                class="accordion accordion-flush"
                id="accordionFlushExample1"
              >
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingThrteen1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThrteen1"
                      aria-expanded="false"
                      aria-controls="flush-collapseThrteen1"
                    >
                      Workshop on 'Big Book Workshop – Pre Primary'
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThrteen1"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingThrteen1"
                    data-bs-parent="#accordionFlushExample1"
                  >
                    <div class="accordion-body">
                      <div class="circular_sec">
                        <LazyLoad>
                         
                          <img
                            src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop13.jpg"
                            class="inner_img"
                            alt="Lotus Valley International School, Greater Noida"
                          />
                        </LazyLoad>
                        <p>
                          “Books are a uniquely portable magic.” – Stephen King
                          To emphasise the importance of reading and utilizing
                          the books as a key resource in the classes, a session
                          on Big Book Programme was conducted on Friday, 18
                          October 2019. The resource person Ms. Neelam Narang
                          from Scholastic enlightened the Pre Primary teachers
                          on the relevance of reading in today’s time and its
                          effective use in teaching various concepts. It began
                          with a mirror reflection activity followed by a
                          discussion on the characteristics of 2-7 years old
                          children. Ms. Narang emphasized the need to mould
                          children to become lifelong readers and encourage
                          their passion towards reading. She made everyone
                          acquainted with the different parts of a Big Book. The
                          key takeaway was creating opportunities for children
                          to think and imagine while reading and giving them
                          enough space to perceive and interpret the story in
                          their own way. The advantages of Big Books over the
                          traditional story books were also discussed. The
                          important aspects of reading aloud such as the change
                          of tone, mood, intensity and pace of reading were
                          emphasized as well. Using these big books in the
                          classroom as a method of integrating various subjects
                          was explained effectively. It was an interactive,
                          engaging and fruitful session with great take aways
                          for the teachers.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingTwel1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwel1"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwel1"
                    >
                      Workshop on 'Session on Menstruation and Menstrual
                      Hygiene'
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwel1"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingTwel1"
                    data-bs-parent="#accordionFlushExample1"
                  >
                    <div class="accordion-body">
                      <div class="circular_sec">
                        <LazyLoad>
                         
                          <img
                            src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop12.jpg"
                            alt="LVISGN"
                            class="inner_img"
                          />
                        </LazyLoad>
                        <p>
                          A session on menstruation and menstrual hygiene was
                          conducted for students of grades VI to VIII by Dr.
                          Kanika Gera, Consultant Gynecologist, Fortis Hospital,
                          Noida. The session gave children an opportunity to
                          understand how and why females menstruate. The speaker
                          also gave students some useful insights into
                          maintaining good hygiene during menstruation,
                          potential risks of keeping poor hygiene during
                          menstruation and ways to effectively and confidently
                          manage the first period. The session helped the
                          children break the taboo around the subject and raise
                          their concerns freely.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingElev1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseElev1"
                      aria-expanded="false"
                      aria-controls="flush-collapseElev1"
                    >
                      Workshop on 'Author Speak by Ms Nandana Dev Sen'
                    </button>
                  </h2>
                  <div
                    id="flush-collapseElev1"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingElev1"
                    data-bs-parent="#accordionFlushExample1"
                  >
                    <div class="accordion-body">
                      <div class="circular_sec">
                        <LazyLoad>
                         
                          <img
                            src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop11.jpg"
                            alt="LVISGN"
                            class="inner_img"
                          />
                        </LazyLoad>
                        <p>
                          The students of grades II, III, IV & V of Lotus Valley
                          International School Noida Extension had a unique
                          opportunity of interacting with the renowned
                          children's author, actor, director and child rights
                          activist, Ms Nandana Dev Sen in the session 'Author
                          Speak' on 1 August, 2019. The versatile author,
                          daughter of the Nobel Laureate Amartya Sen was warmly
                          welcomed by the school Principal, Ms Indu Yadav, with
                          a sapling. Ms Sen began the session by reading
                          excerpts from her books. She interacted with children
                          and shared experiences from her life that inspired her
                          to write. Replete with life lessons, each story,
                          interestingly narrated, left students clamoring for
                          more. Towards the end of the session, Ms Sen took
                          queries from the students related to book writing. It
                          was an enriching, engaging and fruitful session which
                          helped children expand the horizon of their learning.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingTen1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTen1"
                      aria-expanded="false"
                      aria-controls="flush-collapseTen1"
                    >
                      Workshop on 'ARTiculate' at India International Center
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTen1"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingTen1"
                    data-bs-parent="#accordionFlushExample1"
                  >
                    <div class="accordion-body">
                      <div class="circular_sec">
                        <LazyLoad>
                         
                          <img
                            src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop10.jpg"
                            alt="LVISGN"
                            class="inner_img"
                          />
                        </LazyLoad>
                        <p>
                          “The principle of true art is not to portray, but to
                          evoke”- Jerzy Kosinski The teachers attended a one day
                          workshop ‘ARTiculate’ on 17 August 2019 at Indian
                          International Center, New Delhi. The workshop was
                          initiated by Ms. Aditi Misra, former Principal of
                          Delhi Public School, Gurgaon. She did ‘set the tone’
                          for the workshop by stressing on integration of art in
                          every aspect of school curriculum like learning life
                          skills, language and communication, problem solving
                          etc. She emphasized that for each artist, art should
                          come from the heart and it should work as therapy for
                          all. She stressed on individuality of each artist and
                          various stages of artistic development and concluded
                          by encouraging the teachers to take bolder steps as
                          educators to bring out creative and out of the box
                          thinking in our learners. Ms. Madhumita Nandi and Ms
                          Bhavna Srivastava introduced some activities using
                          simple shapes like circles and triangles, which were
                          converted into various hand toys and classroom
                          education tools. They introduced some innovative hands
                          on activity tools like Tangrams, Micrography,
                          Spoonerism, Droodles, colour scheme to teach symmetry
                          ‘Rangometry’ etc. The workshop was quite informative
                          and added value to the attendees.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingNine1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseNine1"
                      aria-expanded="false"
                      aria-controls="flush-collapseNine1"
                    >
                      Celebration of Roald Dahl's birthday and session on
                      storytelling
                    </button>
                  </h2>
                  <div
                    id="flush-collapseNine1"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingNine1"
                    data-bs-parent="#accordionFlushExample1"
                  >
                    <div class="accordion-body">
                      <div class="circular_sec">
                        <LazyLoad>
                         
                          <img
                            src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop9.jpg"
                            alt="LVISGN"
                            class="inner_img"
                          />
                        </LazyLoad>
                        <p>
                          “Having power is not nearly as important as what you
                          choose to do with it”- Roald Dahl Storytelling is an
                          ancient and valuable art that extends around the
                          globe. In this unit, students develop their own
                          storytelling talents, apply the techniques of
                          storytelling, create storytelling guides, and perform
                          a story for an audience. LVISNE celebrated the
                          birthday of a very famous author Roald Dahl which was
                          followed by a story telling session by Ms.Sonia
                          Bareja. Ms.Sonia is a versatile, enthusiastic and
                          creative demonstrator cum educator involved in
                          Training & Creative Development of young adults and
                          children. After the session there was a quiz on Roald
                          Dahl’s work. Students enjoyed the session immensely.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingEight1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseEight1"
                      aria-expanded="false"
                      aria-controls="flush-collapseEight1"
                    >
                      Workshop on ‘An introductory session on 'Teacher as a
                      Counselor'
                    </button>
                  </h2>
                  <div
                    id="flush-collapseEight1"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingEight1"
                    data-bs-parent="#accordionFlushExample1"
                  >
                    <div class="accordion-body">
                      <div class="circular_sec">
                        <LazyLoad>
                         
                          <img
                            src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop8.jpg"
                            alt="LVISGN"
                            class="inner_img"
                          />
                        </LazyLoad>
                        <p>
                          An enriching session on 'Teacher as a Counselor' was
                          conducted by Dr. V.S Ravindran on 24th June, 2019 at
                          LVISNE. It was an interactive session where Dr.
                          Ravindran talked about the different roles of a
                          teacher and how a teacher can be a counselor. A
                          teacher’s role in the past few years has shifted from
                          being a lecturer to a facilitator, a coach and mentor
                          and finally to a counselor who is responsible for the
                          holistic development of a child. A teacher has to don
                          different hats at different times in order to
                          encourage learning as well as build a healthy rapport
                          with the students. He emphasized on the fact that the
                          content is driven by students as well and it is no
                          more teacher-centric. He also said that a supportive
                          atmosphere should be created for every child where
                          every child is respected and valued. A teacher should
                          be friendly with students, but must know where to draw
                          the line. For reinforcing good values and positive
                          behavior in children, teachers should catch them doing
                          the ‘right things’ rather than repeatedly pointing out
                          wrong behavior or mistakes. He regaled the teachers
                          with a lot of anecdotes from his career as an
                          educator, psychologist and counselor, spanning more
                          than 35 years. It was an informative and interactive
                          session with the message- ‘I am not A teacher, I am
                          THE teacher.’
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingSeven1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseSeven1"
                      aria-expanded="false"
                      aria-controls="flush-collapseSeven1"
                    >
                      Workshop on "Mini MBA at School using Hub & Spoke model"
                    </button>
                  </h2>
                  <div
                    id="flush-collapseSeven1"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingSeven1"
                    data-bs-parent="#accordionFlushExample1"
                  >
                    <div class="accordion-body">
                      <div class="circular_sec">
                        <LazyLoad>
                         
                          <img
                            src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop7.jpg"
                            alt="LVISGN"
                            class="inner_img"
                          />
                        </LazyLoad>
                        <p>
                          A workshop was conducted for the teachers of LVISNE by
                          Mr. Amit Agarwal, an MBA and corporate professional,
                          on the art of building key soft skills like optimism,
                          innovation, collaboration, future readiness and
                          adaptability. Children, while growing up, develop a
                          comfortable cocoon of family, close friends and
                          playmates. While that is an intrinsic part of growing
                          up, it can sometimes lead to hesitation in interacting
                          with people who are not part of their social group. In
                          order to prevent this social inhibition, children
                          should be given opportunities to interact, communicate
                          and collaborate as a team with people, apart from
                          their social group. The ‘Hub and Spoke’ model
                          advocated by him can facilitate collaboration between
                          students of different calibre and interests. Giving
                          them projects in which, they work and interact towards
                          achieving a common goal can lead to better social,
                          thinking and communication skills. The teachers talked
                          about various collaborative learning strategies which
                          they have been implementing in their classes and the
                          positive results, thus, seen in many students. It was
                          another step towards providing an enriching ecosystem
                          for teacher empowerment.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingSix1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseSix1"
                      aria-expanded="false"
                      aria-controls="flush-collapseSix1"
                    >
                      Workshop on ‘Teachers plant seeds that grow forever'
                    </button>
                  </h2>
                  <div
                    id="flush-collapseSix1"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingSix1"
                    data-bs-parent="#accordionFlushExample1"
                  >
                    <div class="accordion-body">
                      <div class="circular_sec">
                        <LazyLoad>
                         
                          <img
                            src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop6.jpg"
                            alt="LVISGN"
                            class="inner_img"
                          />
                        </LazyLoad>
                        <p>
                          ’The good teacher explains. The superior teacher
                          demonstrates. The great teacher inspires.’’ -William
                          Arthur Ward. An enriching and interactive workshop on
                          “Teachers plant seeds that grow forever’’ was
                          conducted for teachers on June 27th, 2019 at LVISNE.
                          The workshop was spearheaded by Ms. Usha Pathania,
                          Director-Academics at Mahattattva Education Advisory
                          which empowers schools across the nation. The session
                          aimed at encouraging and motivating the
                          teacher-facilitators to bring in innovations in
                          teaching-learning process. The workshop focused at
                          enhancing the teaching strategies in classrooms for an
                          effective and lifelong learning. It emphasised at
                          enhancing the 21st century skills of students,
                          engaging them in a learning process that goes beyond
                          textbook and create a conducive learning environment
                          for students to find a solution to problems in order
                          to bring about positive changes for a sustainable
                          future. The workshop encompassed a number of
                          activities that were done during the session. The
                          activities were performed by all teachers, like Role
                          Playing, Magazine Cover Making, Jingles, and Street
                          Play. The purpose of the workshop was to ensure that
                          everyone participated in order to understand any
                          concept – broadly, the workshop focused on the idea of
                          Art Integration. The multidisciplinary approach to
                          teaching allows for a better learning outcome thereby,
                          making the child make connect with the outside world
                          and making teaching a meaningful exercise.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingFive1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFive1"
                      aria-expanded="false"
                      aria-controls="flush-collapseFive1"
                    >
                      Workshop on ‘The Art of Story-Telling- Session with Ms.
                      Simmi Srivastava'
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFive1"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingFive1"
                    data-bs-parent="#accordionFlushExample1"
                  >
                    <div class="accordion-body">
                      <div class="circular_sec">
                        <LazyLoad>
                         
                          <img
                            src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop5.jpg"
                            alt="LVISGN"
                            class="inner_img"
                          />
                        </LazyLoad>
                        <p>
                          The story-telling session with Ms. Simmi Srivastava
                          was held on 9 August, 2019 and Teachers across all
                          grades from Pre-Nursery to Grade 4 were in attendance.
                          Ms. Simmi's session highlighted the need to implement
                          story-telling in the classrooms, to transform and
                          enliven the teaching-learning process. The session
                          began with Ms. Simmi narrating the ‘Hungry
                          Caterpillar’ complete with expressions and intonation.
                          It was a surprise to see that although the story is
                          generally for pre-primary students, it could also be
                          woven around topics and concepts usually difficult to
                          understand. Most teachers expressed concern for not
                          being able to hold a student's attention for more than
                          a short span of time. However, Ms. Simmi's narration
                          of 'Geet ka Kamal', was a clear example of how
                          involvement of the students in a story telling session
                          is guaranteed to improve the attention. Lastly, the
                          session brought home the point that story-telling also
                          caters to all three types of learning styles -
                          kinaesthetic, auditory and visual, which is why the
                          lesson or the concept being taught is better absorbed
                          and understood. ‘As educators, we are only as
                          effective as what we know.’ Rightly said, teachers are
                          also learners, and they need to continually hone their
                          skills, improve and implement new tools to make
                          teaching more effective.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingFour1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFour1"
                      aria-expanded="false"
                      aria-controls="flush-collapseFour1"
                    >
                      Workshop on ‘Workshop on Critical and Creative Thinking'
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFour1"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingFour1"
                    data-bs-parent="#accordionFlushExample1"
                  >
                    <div class="accordion-body">
                      <div class="circular_sec">
                        <LazyLoad>
                         
                          <img
                            src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop4.jpg"
                            alt="LVISGN"
                            class="inner_img"
                          />
                        </LazyLoad>
                        <p>
                          "You can't use up creativity. The more you use, the
                          more you have"- Maya Angelou Lotus Valley
                          International School, Noida Extension focuses on the
                          overall development of students. The endeavor is to
                          create curious minds and provide them with the means
                          to ignite creative and independent thinking. For this,
                          an interactive and informative session was conducted
                          by Ms. Suhasini Kanwar on 25th June 2019. Ms Suhasini
                          holds experience in training teachers to match up with
                          the constantly changing teaching strategies. The
                          session focused on multiple intelligences and
                          collaborative strategies that can be implemented in
                          classrooms and to achieve effective learning for the
                          students. The session also threw light on critical and
                          creative thinking, how it can be inculcated and
                          encouraged in students and integrated with the
                          curriculum through activity-based learning. The
                          session was centred around facilitating teachers with
                          practical examples and strategies that can be
                          incorporated in the classroom setting to make learning
                          more effective, interactive and impactful.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingThree1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree1"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree1"
                    >
                      Workshop on ‘Workshop on Story Telling - Once Upon A Time'
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree1"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingThree1"
                    data-bs-parent="#accordionFlushExample1"
                  >
                    <div class="accordion-body">
                      <div class="circular_sec">
                        <LazyLoad>
                         
                          <img
                            src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop3.jpg"
                            alt="LVISGN"
                            class="inner_img"
                          />
                        </LazyLoad>
                        <p>
                          A workshop on Story Telling - Once Upon A Time with
                          participants from various schools on September 14,
                          2019 was being organised at Lotus Valley International
                          School, Noida which was attended by Ms. Surbhi Juneja
                          and Ms. Nidhi Jasrai from Lotus Valley International
                          School, Noida Extension. An interesting session on
                          playing with stories was conducted by Ms. Nupur
                          Aggarwal. It focused on how to spark imagination,
                          build vocabulary, ingrain values and build a
                          connection with the children through stories. The
                          session gave a valuable insight on how a story comes
                          alive through sounds, actions, voice modulation, props
                          and repetition of phrases.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingTwo1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo1"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo1"
                    >
                      Workshop on ‘Session on Positive Psychology'
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo1"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingTwo1"
                    data-bs-parent="#accordionFlushExample1"
                  >
                    <div class="accordion-body">
                      <div class="circular_sec">
                        <LazyLoad>
                         
                          <img
                            src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop2.jpg"
                            alt="LVISGN"
                            class="inner_img"
                          />
                        </LazyLoad>
                        <p>
                          A workshop was held at Lotus Valley International
                          School, Noida Extension on 'Positive Psychology - an
                          introduction to your best version'' by team members of
                          Youniverse, Mr. Sanjeevan Sandhu and Ms. Tanya Bakshi.
                          The resource persons emphasized on mental health for
                          every individual to save them from getting into
                          anxiety and depression. Passion and Purpose were
                          talked about and it was reiterated that ‘Passion’ is
                          what we do solely for ourselves while ‘Purpose’ is
                          when we add value to the lives of others. Also,
                          Emotional Evaluation done everyday ensures that we do
                          not hold grudges for a very long time because it
                          ultimately ends up harming our own mental health. Mr.
                          Sanjeevan & Ms. Tanya also talked about the importance
                          of growth mindset which is ideally what everyone
                          should practice and how it works on positive,
                          problem-solving, optimistic thoughts. They also
                          emphasized practicing gratitude in our everyday lives
                          in order to feel more positive and rejuvenated. The
                          workshop ended on a positive note with a vote of
                          thanks by the Principal, Ms. Indu Yadav.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingOne1">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne1"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne1"
                    >
                      Workshop on 'Session on Empathy by Goonj Foundation'
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne1"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingOne1"
                    data-bs-parent="#accordionFlushExample1"
                  >
                    <div class="accordion-body">
                      <div class="circular_sec">
                        <LazyLoad>
                         
                          <img
                            src="https://webapi.entab.info/api/image/LVISGN/public/Images/workshop1.jpg"
                            alt="LVISGN"
                            class="inner_img"
                          />
                        </LazyLoad>
                        <p>
                          "The world has enough for everyone's needs, but not
                          everyone's greed" -Mahatma Gandhi .As the part of the
                          social surrounding, the Lotus Family considers it a
                          duty to give as much back to the society as is taken
                          from them. For this, Lotus Valley International
                          School, Noida Extension hosted a team from Goonj
                          Foundation on September 11, 2019 to conduct a session
                          on Empathy. The interactive session was conducted for
                          Classes IV and V to generate awareness about the
                          difficulties that the underprivileged children in the
                          rural and urban areas have to face to make ends meet.
                          The students were also encouraged to not discard their
                          belongings but to contribute and share them. The
                          session was concluded with a message and a promise of
                          trying to make a difference to the lives of those who
                          actually need it.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
          </Tabs>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TrainingTrainers;
